<template>
  <div>
    <custom-loading-component />
    <qr-reader ref="qrReader" @reduceSuccess="commitPay" @success="commitQrCode" />

    <cari-select ref="cariSelect" @cari-selected="handleCariSelected" />

    <!-- Ürün Birleştir Modal -->

    <vs-popup id="mergeProductModal" :active.sync="isMergeModalOpen" title="Ürün Birleştir">

      <vs-row vs-type="flex" vs-w="12" vs-justify="center">

        <!-- Başlık ve Mevcut Tutar -->

        <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">

          <div class="bg-white text-primary bold py-3 px-5" style="

              border-radius: 10px;

              border: 1px solid #e1e1e1;

              box-shadow: 0px 3px 6px #00000029;

              font-size: 1.2rem;

            ">

            Yeni Birleşik Ürün Fiyatı Giriniz

          </div>

        </vs-col>



        <!-- Mevcut Toplam -->

        <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">

          <div class="bg-secondary text-primary bold py-2 px-4" style="

              border-radius: 10px;

              border: 1px solid #e1e1e1;

              font-size: 1rem;

            ">

            Mevcut Toplam: {{ $toCurrency(selectedGroupsPrice) }}

          </div>

        </vs-col>



        <!-- Ödenen Tutar (varsa) -->

        <vs-col v-if="totalPayedPriceForMerge > 0" vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">

          <div class="bg-warning text-white bold py-2 px-4" style="

              border-radius: 10px;

              border: 1px solid #e1e1e1;

              font-size: 1rem;

            ">

            Ödenen Tutar: {{ $toCurrency(totalPayedPriceForMerge) }}

          </div>

        </vs-col>



        <!-- Fiyat Input -->

        <vs-col vs-type="flex" vs-w="8" vs-justify="center" class="mb-4">

          <input autofocus="true" id="txtMergePrice" ref="txtMergePrice" name="mergePrice" autocomplete="off"
            size="large" type="text" v-model="newMergePrice" class="bold w-full price-input" placeholder="0.00" />

        </vs-col>



        <!-- Sanal Klavye -->

        <vs-col vs-type="flex" vs-w="10" vs-justify="center">

          <vs-row vs-type="flex" vs-w="12">

            <!-- Sayılar 1-9 -->

            <vs-col vs-type="flex" vs-w="4" v-for="number in numbers" :key="number" class="my-1 px-1">

              <vs-button color="transparent" @click="appendToPrice(number)"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;">

                {{ number }}

              </vs-button>

            </vs-col>



            <!-- Alt satır: 0, ., Sil -->

            <vs-col vs-type="flex" vs-w="4" class="my-1 px-1">

              <vs-button @click="appendToPrice('0')" color="transparent"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;">

                0

              </vs-button>

            </vs-col>

            <vs-col vs-type="flex" vs-w="4" class="my-1 px-1">

              <vs-button @click="appendToPrice('.')" color="transparent"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;">

                .

              </vs-button>

            </vs-col>

            <vs-col vs-type="flex" vs-w="4" class="my-1 px-1">

              <vs-button color="transparent" @click="clearPrice"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;">

                Sil

              </vs-button>

            </vs-col>

          </vs-row>

        </vs-col>



        <!-- Onayla ve İptal Butonları -->

        <vs-col vs-type="flex" vs-w="8" vs-justify="center" class="mt-4">

          <vs-row vs-type="flex" vs-w="12">

            <vs-col vs-type="flex" vs-w="6" class="pr-2">

              <vs-button @click="confirmMergeFromModal"
                :disabled="!newMergePrice || parseFloat(newMergePrice) <= 0 || parseFloat(newMergePrice) < totalPayedPriceForMerge"
                color="transparent" class="bg-success text-white w-full bold py-4"
                style="font-size: 1.3rem; min-height: 55px;">

                Onayla

              </vs-button>

            </vs-col>

            <vs-col vs-type="flex" vs-w="6" class="pl-2">

              <vs-button @click="cancelMerge" color="transparent" class="bg-danger text-white w-full bold py-4"
                style="font-size: 1.3rem; min-height: 55px;">

                İptal

              </vs-button>

            </vs-col>

          </vs-row>

        </vs-col>

      </vs-row>

    </vs-popup>

    <vs-row vs-type="block" vs-w="12">

      <vs-popup fullscreen :active.sync="isActive" id="orderList">

        <calc v-if="isPosEnabled" ref="calculatorPage" @closeEvent="closeCalculatorPage" @doPay="doPay"
          @setIsPieced="setIsPieced" @open-discount="openDiscountModal" :totalPrice="separatePaymentPrice" :currentDate="currentDate"
          :currentTime="currentTime" />

        <calc v-if="!isPosEnabled" ref="calculatorPage" @closeEvent="closeCalculatorPage" @doPay="doPayWithoutPos"
          @open-discount="openDiscountModal" :totalPrice="separatePaymentPrice" :currentDate="currentDate" :currentTime="currentTime" />

        <vs-row vs-type="flex" vs-w="12" class="p-0 m-0 relative">

          <vs-button size="large" color="transparent" class="payment-label bg-primary2 text-white w-full"
            icon-pack="feather" icon="icon-credit-card">

            Ödeme Ekranı-{{ currentCart ? currentCart.name : "" }} - {{ activePersonel ? activePersonel.name : "" }}

          </vs-button>

          <vs-button @click="isActive = false" size="large" color="transparent"
            class="block md:hidden close-btn large-icon text-white w-full absolute" icon-pack="feather" icon="icon-x">

          </vs-button>

        </vs-row>

        <vs-row vs-type="flex" vs-w="12" class="info-row px-3" vs-justify="space between" v-if="activePersonel">

          <vs-col vs-w="6" vs-type="flex" vs-justify="flex-start" vs-align="center">

            <p class="text-primary bold">Personel Adı :</p>

            <p class="text-primary ml-2 weight-500">

              {{ activePersonel ? activePersonel.name : "" }}

            </p>

          </vs-col>

          <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end" vs-align="center">

            <p class="text-primary weight-600 mr-3">{{ currentDate }}</p>

            <p class="text-primary weight-500">{{ currentTime }}</p>

          </vs-col>

        </vs-row>

        <div id="data-list-thumb-view" class="data-list-container">

          <vs-table multiple :data="sortedPaymentGroups" v-model="selectedPaymentGroup" id="orderListTable">

            <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between"></div>

            <template slot="thead">

              <vs-th class="w-6/12">
                <p class="column-head-text">Ürün</p>
              </vs-th>

              <vs-th v-if="!isMobile" class="w-2/12">
                <p class="column-head-text">Ekstra</p>
              </vs-th>

              <th v-if="hasTimeProducts && !isMobile" class="w-2/12">
                <p class="column-head-text text-center">Süre Bilgi</p>
              </th>

              <vs-th class="w-2/12">
                <p class="column-head-text">Fiyat</p>
              </vs-th>

            </template>

            <template slot-scope="{ data }">

              <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr" style="min-height: 5rem"
                :class="{ 'bg-secondary2': indextr % 2 != 0 }">

                <vs-td class="w-6/12">

                  <vs-row vs-type="block" vs-w="12" v-for="entry in tr.entries" :key="entry.id">

                    <p class="text-left text-sm font-bold text-primary">

                      {{

                        entry.productName +

                        (entry.quantity > 1 ? " - x" + entry.quantity : "")

                      }}

                    </p>
                    <div v-if="(entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.recipeSteps || entry.RecipeSteps || entry.steps || entry.Steps)">
                      <p
                        v-for="(rawmaterial, rawMaterialIndex) in (entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || entry.recipeSteps || entry.RecipeSteps || entry.steps || entry.Steps || []"
                        v-if="rawmaterial && (rawmaterial.isRemoved || rawmaterial.IsRemoved || rawmaterial.is_removed || rawmaterial.is_Removed || (rawmaterial.selected && !rawmaterial.isDefault) || (rawmaterial.Selected && !rawmaterial.IsDefault) || (rawmaterial.isSelected && !rawmaterial.isDefault) || (rawmaterial.selected && !rawmaterial.IsDefault) || (rawmaterial.Selected && !rawmaterial.isDefault) || rawmaterial.isRemoved === true || rawmaterial.IsRemoved === true || rawmaterial.is_removed === true || (rawmaterial.selected === true && rawmaterial.isDefault === false))"
                        :key="rawMaterialIndex"
                        :class="{'line-through': rawmaterial.isRemoved || rawmaterial.IsRemoved || rawmaterial.is_removed || rawmaterial.is_Removed}"
                        class="text-primary product-extra tr-text-child text-left"
                      >
                         {{ (rawmaterial.name || rawmaterial.Name || (rawmaterial.rawMaterial && rawmaterial.rawMaterial.name) || (rawmaterial.rawMaterial && rawmaterial.rawMaterial.Name) || (rawmaterial.rawmaterial && rawmaterial.rawmaterial.name) || (rawmaterial.rawmaterial && rawmaterial.rawmaterial.Name) || '').trim() }}
                      </p>
                    </div>

                  </vs-row>

                </vs-td>

                <vs-td v-if="!isMobile" class="w-4/12">

                  <vs-row vs-type="block" vs-w="12" v-for="entry in tr.entries" :key="entry.rowId">

                    <span class="tr-text-child text-center text-primary" v-for="extra in entry.extras" :key="extra.id">

                      <p class="product-extra text-primary" v-if="extra.quantity > 0 && (!extra.variants || extra.variants.length == 0)">

                        x{{ extra.quantity }} / {{ extra.name }}

                      </p>

                      <p style="display: block" class="product-extra text-primary" v-else-if="extra.variants && extra.variants.length > 0"
                        v-for="seletedVariantExtra in returnSelectedExtraVariant(

                          extra

                        )" :key="seletedVariantExtra">

                        {{ seletedVariantExtra }}

                      </p>

                    </span>

                  </vs-row>

                </vs-td>

                <!-- v146: Süreli ürün bilgi kolonu "Süre Bilgi" olarak adlandırıldı ve "Ekstra" sonrasına taşındı -->
                <vs-td v-if="hasTimeProducts && !isMobile" class="w-3/12" style="padding: 4px;" @click.stop="">
                  <div v-if="tr.entries.find(entry => entry.isTime)" class="time-control-wrapper" style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
                    <div class="time-display-desktop" style="background: rgba(var(--vs-primary), 0.05); padding: 4px 12px; border-radius: 6px; border: 1px solid rgba(var(--vs-primary), 0.1); display: flex; align-items: center; justify-content: center; gap: 8px;">
                      <p class="text-xs text-center text-primary font-bold" style="font-size: 0.85rem; white-space: nowrap; margin: 0;">
                        {{ getDisplayTimeRange(tr.entries.find(entry => entry.isTime)) }}
                      </p>
                      <vs-button
                        v-if="tr.entries.find(entry => entry.isTime).isRunning && $isAdmin()"
                        radius
                        color="warning"
                        type="flat"
                        icon="icon-edit"
                        icon-pack="feather"
                        size="small"
                        style="padding: 4px; margin: 0; min-width: unset;"
                        @click.native.stop="openStopTimeEditPopup(tr)"
                      />
                    </div>
                  </div>
                </vs-td>

                <!-- Fiyat Kolonu -->
                <vs-td class="w-1/6">


                  <span v-if="tr.payedPrice > 0 && tr.payedPrice != tr.totalPrice" class="text-center text-primary tr-text w-full line-through">
                    {{ $toCurrency(tr.totalPrice) }}
                  </span>

                  <p class="text-center text-primary tr-text w-full" :class="{
                    'payed-row': $isRowPaid(tr),
                    'clickable-price': !$isRowPaid(tr) && $isAdmin()
                  }" @click="openPriceEditDialog(tr)">
                    {{
                      !$isRowPaid(tr)
                        ? (tr.entries.some(entry => entry.isTime && entry.isRunning)
                          ? $toCurrency(calculateCurrentPrice(tr))
                          : $toCurrency(tr.totalPrice - tr.payedPrice))
                        : "Ödendi"
                    }}
                  </p>
                </vs-td>

              </vs-tr>

            </template>

          </vs-table>

          <vs-row vs-type="flex" vs-w="12" class="px-5" style="background: #ffd1d1 !important; height: 60px">

            <vs-col vs-type="flex" :vs-w="isMobile ? 6 : 5" vs-justify="flex-start">
              <div class="w-auto flex flex-col justify-center">
                <div class="d-flex align-center pointer" style="line-height: 1.2;">
                  <span class="price-label bold mr-2 text-sm" :style="isMobile ? 'font-size: 0.8rem !important' : ''">
                    Genel: <span class="text-primary">{{ $toCurrency(totalOriginPrice) }}</span>
                  </span>
                  <span v-if="totalPaidAmount > 0" class="price-label bold mr-2 text-sm text-warning" :style="isMobile ? 'font-size: 0.8rem !important' : ''">
                    Ödenen: <span>{{ $toCurrency(totalPaidAmount) }}</span>
                  </span>
                </div>
                <div class="d-flex align-center pointer mt-1">
                  <p class="price-label bold mr-3" :style="isMobile ? 'font-size: 1rem !important' : ''">
                    {{ isMobile ? "Kalan:" : "Kalan Tutar:" }}
                  </p>
                  <p class="price bold mr-3 text-danger" :style="isMobile ? 'font-size: 1rem !important' : ''">
                    {{ $toCurrency(totalPrice) }}
                  </p>
                  <vs-button v-show="orderPayments != null && orderPayments.length > 0"
                    @blur="showPaymentHistory = false" @click="showPaymentHistory = !showPaymentHistory"
                    icon-pack="feather" icon="icon-more-horizontal" radius size="small" color="transparent"
                    class="sale-box-shadow bg-secondary text-primary" />
                </div>
              </div>
            </vs-col>

            <vs-col v-if="!isMobile || (this.isPosEnabled && this.posType == this.VUE_APP_POS_CLOUD)" vs-type="flex"
              vs-w="2" vs-justify="center">

              <vs-checkbox v-if="!isMobile" class="bold text-primary" v-model="isPrintOrders">Fiş
                Yazdırılsın</vs-checkbox>



                <div class="copy-count-wrap">
                  <span class="copy-count-label">Kopya</span>
                  <input type="number" v-model.number="printCopyCount" min="1" class="copy-count-input" />
                </div>
                <vs-button @click="printBill" :disabled="isPrinting" color="transparent" class="text-white sale-box-shadow half-friendly-border bg-primary mr-2 my-1 whitespace-no-wrap">
                  <i v-if="!isPrinting" class="mr-1"></i>
                  <i v-if="isPrinting" class="feather icon-loader rotating mr-1"></i>
                  {{ isPrinting ? 'Yazdırılıyor...' : 'Yazdır' }}
                </vs-button>



              <!-- <vs-checkbox class="bold text-primary"

               v-if="isPosEnabled && posType == VUE_APP_POS_CLOUD" v-model="manuelPayment"

                >Manuel Ödeme</vs-checkbox

              > -->

            </vs-col>



            <vs-col vs-type="flex" :vs-w="isMobile ? 6 : 5" vs-justify="flex-end">

              <div class="flex justify-flex-end align-center" style="width: 100%; justify-content: flex-end;">

                <p class="price-label bold mr-5" :style="isMobile ? 'font-size: 1rem !important' : ''">

                  {{ isMobile ? "Seçilen:" : "Seçilen Tutar:" }}

                </p>

                <p class="price bold" :style="isMobile ? 'font-size: 1rem !important' : ''">

                  {{ $toCurrency(selectedGroupsPrice) }}

                </p>

              </div>

            </vs-col>

          </vs-row>

          <vs-row vs-type="flex" vs-w="12" class="relative">

            <vs-col vs-type="block" :vs-w="isMobile ? 6 : 2">

              <transition name="fade">

                <div v-show="showPaymentHistory && orderPayments.length > 0"
                  class="payment-history w-full text-primary">

                  <vs-row vs-type="flex" vs-w="12">

                    <vs-row class="payment-log bold" vs-type="flex" vs-w="12" vs-justify="center"
                      v-for="log in orderPayments" :key="log.id">

                      {{ $toCurrency(log.price) }} {{ log.paymentMethod.name }}
                      <span v-if="log.paymentMethod.id == 4 && log.unit == '%'" class="ml-1">(%{{ log.value }})</span>

                    </vs-row>

                  </vs-row>

                </div>

              </transition>

            </vs-col>

            <vs-col vs-type="block" :vs-w="12" class="px-8" style="z-index: 9">

              <vs-row vs-type="flex" vs-w="12">

                <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-3">

                  <select-payment-type ref="selectPaymentType" :dontCloseCalc="false" :totalPrice="totalPrice"
                    :currentDate="currentDate" :currentTime="currentTime" :isPaymentBlocked="hasRunningTimeProducts" 
                    :hasDiscount="totalDiscountPrice > 0" :canResetDiscount="totalPaidAmount == 0"
                    @open-discount="openDiscountModal" @stop-all-timers="stopAllRunningTimeProducts"
                    @reset-discount="resetDiscount" />

                  <vs-button v-if="false && selectedPaymentGroup.length > 1" @click="mergeSelectedProducts" color="transparent"
                    class="text-white bg-warning bold sale-box-shadow ml-3" style="height: 48px; font-size: 1rem;"
                    icon-pack="feather" icon="icon-layers">

                    Ürün Birleştir

                  </vs-button>


                </vs-row>

                <vs-row v-if="isPosEnabled && isPosConnectionError" vs-type="flex" vs-justify="center" class="mb-2 mt-4 w-full">
                  <div class="w-full text-center py-2 px-4 bg-danger text-white bold half-friendly-border" style="border-radius: 8px; box-shadow: 0px 3px 6px rgba(0,0,0,0.16);">
                    <i class="feather icon-wifi-off mr-2"></i>
                    POS Bridge Bağlantısı Koptu! Lütfen Servisi Kontrol Edin.
                  </div>
                </vs-row>

                <vs-row vs-type="flex" vs-justify="center" class="mt-16 md:mt-4 action-btns">

                  <vs-col vs-type="flex" vs-justify="flex-end" class="hidden md:flex pr-2 w-1/4">

                    <vs-button @click="isActive = false" :disabled="isCommitable && isPosEnabled" size="large"
                      color="primary" type="gradient" class="bold half-friendly-border sale-box-shadow w-full text-sm text-white"
                      icon-pack="feather" icon="icon-arrow-left">

                      Geri Dön

                    </vs-button>

                  </vs-col>

                  <vs-col v-if="$isAdmin()" class="w-1/2 md:w-1/4 pr-2">

                    <vs-button :disabled="!selectedPaymentGroup.length" size="large" color="primary" type="gradient"
                      class="bold half-friendly-border sale-box-shadow w-full text-sm h-full text-white" icon-pack="feather"
                      icon="icon-trash" @click="ClearCart">

                      Seçili Ürünleri Sil

                    </vs-button>

                  </vs-col>

                  <vs-col v-if="selectedPaymentGroup.length == 1 && selectedPaymentGroup[0].entries[0].quantity > 1"
                    class="w-1/2 md:w-1/4 pr-2">

                    <vs-button :disabled="!selectedPaymentGroup.length" size="large" color="primary" type="gradient"
                      class="bold half-friendly-border sale-box-shadow w-full text-sm h-full text-white" icon-pack="feather"
                      icon="icon-trash" @click="breakToRow">
                      Parçala
                    </vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="flex-start" class="w-1/2 md:w-1/4">
  <vs-button v-if="(!isCommitable && totalPrice > 0) && isPosEnabled" color="transparent"
    class="text-white bg-success py-4 bold sale-box-shadow w-full text-base"
    :disabled="hasRunningTimeProducts || isTransaction || (isPosConnectionError && selectedPaymentMethod && (selectedPaymentMethod.id == VUE_APP_CASH_PAYMENT_ID || selectedPaymentMethod.id == VUE_APP_CREDIT_PAYMENT_ID))" @click="
                        doPay(
                          selectedPaymentGroup.length > 0
                            ? selectedGroupsPrice
                            : totalPrice,
                          false
                        )
                        ">
                      {{
                        posType == this.VUE_APP_POS_CLOUD && !manuelPayment &&
                          (selectedPaymentMethod && (selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID ||
                            selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID))

                          ? "Cihaza gönder"
                          : (selectedPaymentMethod ? selectedPaymentMethod.name + " ile Öde" : null)
                      }}
                    </vs-button>
                    <vs-button v-if="(!isCommitable && totalPrice > 0) && !isPosEnabled" color="transparent"
    class="text-white bg-success px-1 py-4 bold sale-box-shadow w-full text-sm"
    :disabled="hasRunningTimeProducts || isTransaction" @click="
                        doPayWithoutPos(

                          selectedPaymentGroup.length > 0
                            ? selectedGroupsPrice
                            : totalPrice,
                          false
                        )
                        ">
                      {{
                        selectedPaymentMethod
                          ? selectedPaymentMethod.name

                          : null
                      }}
                      ile Öde
                      {{
                        selectedPaymentGroup.length > 0
                          ? $toCurrency(selectedGroupsPrice)
                          : $toCurrency(totalPrice)
                      }}

                    </vs-button>

                    <transition name="slide-fade">

                      <vs-button :disabled="isTransaction" v-if="isCommitable" size="large" color="transparent"
                        @click="createCommitModel" class="glowing w-64 text-white bg-success3 bold sale-box-shadow">

                        Sepeti Bitir

                      </vs-button>

                    </transition>

                  </vs-col>

                </vs-row>

              </vs-row>

            </vs-col>

            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" class="absolute top-0 right-0">

              <div class="bg-secondary calc-button sale-box-shadow" @click.stop="totalPrice != 0 ? seperatePayment() : null">

                <vs-button :disabled="totalPrice == 0" color="transparent" type="flat"
                  class="small-icon text-primary p-0" icon-pack="feather" icon="icon-chevron-left" />

                <vs-button :disabled="totalPrice == 0" color="transparent" type="flat"
                  class="large-icon text-primary p-0" icon-pack="feather" icon="icon-percent" />

              </div>

            </vs-col>

          </vs-row>

        </div>

        <div style="display: none;">
        </div>

        <discount ref="discount" @appendDiscount="appendDiscount" :priceToDiscount="selectedPaymentGroup.length > 0 ? selectedGroupsPrice : totalPrice

          " :currentDate="currentDate" :currentTime="currentTime" />

    <vs-popup title="Süre Durdurma Zamanı Düzenle" :active.sync="stopTimeEditPopupActive" class="stop-time-edit-popup">
      <div class="p-4">
        <p class="mb-2">Ürün: <strong>{{ selectedPaymentGroupForTimeEdit && selectedPaymentGroupForTimeEdit.entries && selectedPaymentGroupForTimeEdit.entries[0] ? selectedPaymentGroupForTimeEdit.entries[0].productName : '' }}</strong></p>

        <div class="flex flex-col mb-4">
          <label class="mb-1">Başlangıç Zamanı Seçin:</label>
          <input 
            type="datetime-local" 
            ref="startTimePicker" 
            @click="openPicker('startTimePicker')" 
            v-model="customStartTime" 
            class="vs-inputx vs-input--input normal w-full" 
            style="border: 1px solid rgba(0,0,0,0.2); border-radius: 6px; padding: 0.6rem 0.8rem; font-size: 0.9rem; outline: none; cursor: pointer;" 
          />
        </div>

        <div class="flex flex-col mb-4">
          <label class="mb-1">Durdurma Zamanı Seçin:</label>
          <input 
            type="datetime-local" 
            ref="stopTimePicker" 
            @click="openPicker('stopTimePicker')" 
            v-model="customStopTime" 
            class="vs-inputx vs-input--input normal w-full" 
            style="border: 1px solid rgba(0,0,0,0.2); border-radius: 6px; padding: 0.6rem 0.8rem; font-size: 0.9rem; outline: none; cursor: pointer;" 
          />
        </div>

        <div class="flex justify-end mt-4">
          <vs-button color="danger" class="mr-3" @click="stopTimeEditPopupActive = false">
            İptal
          </vs-button>
          <vs-button color="warning" @click="saveAndStopTimer" :disabled="!customStopTime || !customStartTime">
            Kaydet ve Süreyi Durdur
          </vs-button>
        </div>
      </div>
    </vs-popup>

      </vs-popup>
      
      <div style="display: none;">
        <printer ref="printer" printerId="printerDesktop" 
          :printCopyCount="printCopyCount" 
          :orderEntries="snapshotBillEntries && snapshotBillEntries.length > 0 ? snapshotBillEntries : orderBillEntries" 
          :totalPrice="snapshotTotalPaidAmount !== null ? snapshotTotalPaidAmount : totalPaidAmount"
          :totalOriginPrice="snapshotTotalOriginPrice || totalOriginPrice"
          :totalDiscountPrice="(snapshotTotalDiscountPrice !== null && snapshotTotalDiscountPrice !== undefined) ? snapshotTotalDiscountPrice : totalDiscountPrice" 
          :currentDateTime="currentDate + ' ' + currentTime"
          :activePersonal="activePersonel ? activePersonel.name + ' ' + activePersonel.surname : ''" 
          :billNo="orderBillNo" 
          :tableName="snapshotTableName || tableName" 
          :branchName="$store.state.AppActiveUser.branch.name" 
          :connection="connection" 
          :orderPayments="(snapshotOrderPayments && snapshotOrderPayments.length > 0) ? snapshotOrderPayments : (currentCart && currentCart.orderPayments ? currentCart.orderPayments : [])" />
      </div>

    </vs-row>

    <vs-popup title="Fiyat Düzenle" :active.sync="priceEditPopupActive" class="price-edit-popup">

      <div class="p-4">

        <p class="mb-2">Ürün: <strong>{{ selectedPaymentGroupForEdit ?
          selectedPaymentGroupForEdit.entries[0].productName :
          '' }}</strong></p>



        <div class="flex flex-col mb-4">

          <label class="mb-1">Mevcut Fiyat:</label>

          <p class="text-primary font-bold">{{ selectedPaymentGroupForEdit ?
            $toCurrency(selectedPaymentGroupForEdit.totalPrice - selectedPaymentGroupForEdit.payedPrice) : '' }}</p>

        </div>



        <div class="flex flex-col mb-4">

          <label class="mb-1">Yeni Fiyat:</label>

          <vs-input type="number" v-model="newPrice" class="w-full" step="0.01" min="0" />

        </div>



        <div class="flex justify-end">

          <vs-button color="danger" class="mr-3" @click="priceEditPopupActive = false">

            İptal

          </vs-button>

          <vs-button color="primary" @click="updatePrice">

            Güncelle

          </vs-button>

        </div>

      </div>

    </vs-popup>

    <vs-popup :active.sync="isDescriptionPromptActive" title="Açıklama Gerekli" class="description-prompt-popup">
      <div class="p-4">
        <p class="mb-4 bold text-primary">{{ descriptionPromptText }}</p>
        <vs-textarea v-model="pendingDescription" label="İşlem Açıklaması (Zorunlu)" class="w-full"
          placeholder="Lütfen bir açıklama giriniz..." />
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button @click="cancelDescriptionPrompt" color="danger" type="flat" class="mr-2">Vazgeç</vs-button>
          <vs-button @click="confirmDescriptionPrompt" color="success" :disabled="!pendingDescription || pendingDescription.trim() === ''">Onayla</vs-button>
        </vs-row>
      </div>
    </vs-popup>

  </div>

</template>



<script>

import Discount from "./Discount";

import Printer from "./Printer.vue";

import Calc from "./Calc.vue";

import CustomLoadingComponent from "@/views/pages/customLoadingComponent";

import QrReader from "./QrReader.vue";

import CariSelect from "./CariSelect.vue";

import { uuid } from "vue-uuid";

import { completePayment, addDiscountLog } from "@/api/SelfService";

import SelectPaymentType from "./SelectPaymentType.vue";

import { FindAvailableCampaigns } from "@/api/Campaign.js";

import { getPosSettings } from "@/api/AppSettings";

import {
  setBranchCart,
  removeToCartIds,
  getCarts,
  reserveTable,
  unReserveTable,
  breakToRow,
  getOrderEntries,
  splitCart,
  getCartsByTableId,
  triggerKitchenPrintBySID
} from "@/api/Cart";

import { SendOrder } from "@/api/PavoCloud";

export default {

  props: {
    currentTime: {
      type: String,
      required: true,
    },
    currentDate: {
      type: String,
      required: true,
    },
    isTableMode: {
      type: Boolean,
      required: true,
    },
    editOrderMode: {
      type: Boolean,
      required: false,
    },
    tableName: {
      type: String,
      required: false,
    },
    connection: {
      type: Object,
      required: false,
      default: null
    }
  },

  components: {

    CustomLoadingComponent,

    Calc,

    SelectPaymentType,

    Printer,

    Discount,

    QrReader,

    CariSelect,

  },

  data() {

    return {

      cloneCurrentCart: [],

      selectedGift: null,

      isPosEnabled: false,

      isPrintOrders: true,
      printCopyCount: 1,


      isTransaction: false,

      showPaymentHistory: false,

      isCommitable: false,

      selectedPaymentGroup: [],

      isActive: false,

      orderPayments: [],

      paymentGroups: [],

      separatePaymentPrice: 0,

      paymentDiscount: {},

      discounts: [],

      ids: [],

      isPieced: false,

      posType: 0,

      orderBillNo: 0,

      isMobile: null,

      posData: {},

      VUE_APP_POS_CLOUD: parseInt(process.env.VUE_APP_POS_CLOUD),

      VUE_APP_CASH_PAYMENT_ID: parseInt(process.env.VUE_APP_CASH_PAYMENT_ID),

      VUE_APP_CREDIT_PAYMENT_ID: parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID),

      manuelPayment: false,

      selectedCari: null,

      priceEditPopupActive: false,

      selectedPaymentGroupForEdit: null,

      newPrice: 0,

      stopTimeEditPopupActive: false,
      selectedPaymentGroupForTimeEdit: null,
      customStartTime: "",
      customStopTime: "",
      minStopTime: "",
      maxStopTime: "",

      // Loading states

      isPrinting: false,

      // Merge modal data

      isMergeModalOpen: false,

      isCalculatorPageActive: false,
      newMergePrice: "",

      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],

      selectedGroupsForMerge: [],

      totalPayedPriceForMerge: 0,

      isDescriptionPromptActive: false,
      descriptionPromptText: "",
      descriptionPromptCallback: null,
      pendingDescription: "",
      snapshotBillEntries: [],
      snapshotTableName: "",
      snapshotTotalOriginPrice: null,
      snapshotTotalDiscountPrice: null,
      snapshotTotalPrice: null,
      snapshotTotalPaidAmount: null,
      snapshotOrderPayments: null,
      localMergedIds: [],
      snapshotBillEntries: [],
      snapshotTotalOriginPrice: 0,
      snapshotTotalDiscountPrice: 0,
      snapshotTableName: "",
      
      submissionId: null,
      localBranchTableUId: null,
      localBranchId: null,
      kitchens: [],
      showOperationDetails: false,
      timerInterval: null,
      isTimerActionInProgress: false,
      isPosConnectionError: false,
      posConnectionInterval: null
    };
  },

  watch: {

    selectedPaymentGroup(newVal, oldVal) {

      if (newVal.length > 0) {

        var lastItem = newVal[newVal.length - 1];

        if (lastItem.totalPrice > 0 && lastItem.totalPrice == lastItem.payedPrice) {
          this.selectedPaymentGroup = oldVal;
        }

      }

    },

    printCopyCount(newVal) {
      localStorage.setItem("printCopyCount", newVal);
    },
    isPrintOrders(val) {
      localStorage.setItem("isPrintOrders", val);
    },


    isActive: function (val) {
      if (val) {
        this.checkPosDevice().then(() => {
          this.startPosConnectionTimer();
        });
        this.initValues();
        this.initGifts();
        this.loadKitchens();

        const sessionPaymentMethods = this.$store.getters["selfservice/getPaymentMethods"];
        if (sessionPaymentMethods && sessionPaymentMethods.length > 0) {
          const creditId = process.env.VUE_APP_CREDIT_PAYMENT_ID ? parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID) : 2;
          const creditCardMethod = sessionPaymentMethods.find(m => m.id == creditId);
          if (creditCardMethod) {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", creditCardMethod);
          } else {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", sessionPaymentMethods[0]);
          }
        }

        if (this.totalPrice <= 0) {
          this.isCommitable = true;
        }
        this.broadcastCartState();

      } else {
        this.stopPosConnectionTimer();
        this.isPosConnectionError = false;
        this.selectedPaymentGroup = [];
        this.paymentGroups = [];
        this.orderPayments = [];
        this.discounts = [];
        this.isCommitable = false;
        this.submissionId = null;
        this.snapshotTotalDiscountPrice = 0;
        this.snapshotTotalOriginPrice = 0;
        this.snapshotTotalPrice = null;
        this.snapshotOrderPayments = null;
        this.snapshotBillEntries = [];
        this.snapshotTableName = "";
        this.localMergedIds = [];
        this.broadcastCartState();
      }

    },

    totalPrice: function (val) {
      const roundedVal = Math.round(val * 100) / 100;
      if (roundedVal <= 0) {
        this.isCommitable = true;
        // totalPrice watcher üzerinden otomatik tetikleme riskli (race condition), 
        // ancak kullanıcı çok istiyorsa burada isTransaction kontrolüyle bir kez denenebilir.
        // Şimdilik ödeme sonuçlarına (doPay) güveniyoruz.
      } else {
        this.isCommitable = false;
      }
    },

    selectedPaymentMethod(val) {
      if (val && val.id == 4 && !this.isTransaction) {
        this.isActiveDiscount = true;
      }
    },

    paymentGroups: {
      deep: true,
      handler() {
        this.broadcastCartState();
      }
    },

    orderPayments: {
      deep: true,
      handler() {
        this.broadcastCartState();
      }
    },

  },

  computed: {

    orderBillEntries: {
      get() {
        try {
          // currentCart.cartEntries'den orderBillEntries'i oluştur, isTime ve totalHour bilgilerini koru
          let currentCart = this.$store.getters["selfservice/getCurrentCart"];
          
          // FIX [v22]: Polling sırasında cart.active kaybolursa UUID bazlı geri yükle (Fallback)
          if (!currentCart && this.localBranchTableUId) {
             console.warn("orderBillEntries (Desktop Recovery): currentCart is NULL, attempting recovery by UUID:", this.localBranchTableUId);
             const allCarts = this.$store.getters["selfservice/getCarts"];
             currentCart = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
             if (currentCart) console.log("orderBillEntries (Desktop fallback): Cart found.");
          }

          console.log("orderBillEntries - currentCart:", currentCart);

          if (!currentCart || !currentCart.cartEntries) {
            console.log("orderBillEntries: currentCart veya cartEntries yok");
            return [];
          }

          // cartEntries'i kopyala ve süreli ürün bilgilerini ekle
          const result = currentCart.cartEntries.map(entry => {
            // v149 [STRICT-LOGIC]: Kullanıcının DB kuralına göre: IsRunning=false ise süreli üründür.
            const rawIsRunning = (entry.isRunning === false || entry.IsRunning === false) ? false : true;
            const isTimedRaw = (rawIsRunning === false);

            // Güvenli kopyalama
            const processedEntry = {
              id: entry.id,
              productName: entry.productName,
              price: entry.price,
              originPrice: entry.originPrice || entry.price,
              quantity: entry.quantity,
              productQuantity: entry.productQuantity,
              note: entry.note,
              variantItems: entry.variantItems || [],
              description: entry.description,
              // Süreli ürün bilgileri
              isTime: isTimedRaw,
              totalHour: entry.totalHour || entry.TotalHour || 0,
              isRunning: rawIsRunning,
              hourPrice: entry.hourPrice || entry.HourPrice || 0,
              time: entry.time || entry.Time,
              createdDate: entry.createdDate,
              userName: entry.userName,
              recipe: entry.recipe,
              extras: entry.extras,
              lastStartTime: entry.lastStartTime || entry.LastStartTime,
              lastStopTime: entry.lastStopTime || entry.LastStopTime,
            };

            // v149.1: Eğer süreli ürünse ve totalHour yoksa, zaman damgalarından hesapla (Duration = Stop - Start)
            if (processedEntry.isTime && (!processedEntry.totalHour || processedEntry.totalHour <= 0)) {
                const start = this.parseSafeDate(processedEntry.lastStartTime || processedEntry.createdDate);
                const stop = this.parseSafeDate(processedEntry.lastStopTime || new Date());
                if (start.getTime() > 0 && stop.getTime() >= start.getTime()) {
                    processedEntry.totalHour = (stop.getTime() - start.getTime()) / (1000 * 60 * 60);
                }
            }

            // v111.6: Reçete isim güvenliği (Adisyon/Snapshot öncesi - Max Safety)
            const targetRecipe = processedEntry.recipe || processedEntry.Recipe || processedEntry.recipeSteps || processedEntry.RecipeSteps;
            if (targetRecipe && targetRecipe.steps) {
              targetRecipe.steps.forEach(step => {
                if (step.isRemoved) {
                    const rawMat = step.rawMaterial || step.RawMaterial || step.raw_material;
                    const pName = step.productName || step.ProductName || (step.product && (step.product.name || step.product.Name));
                    const safeName = (rawMat && (rawMat.name || rawMat.Name)) ? (rawMat.name || rawMat.Name) : 
                                   (pName ? pName : (step.name || step.Name || "Malzeme"));
                    if (!step.name || step.name === "Malzeme") step.name = safeName;
                    if (!step.Name || step.Name === "Malzeme") step.Name = safeName;
                    if (!step.productName) step.productName = safeName;
                }
              });
              processedEntry.recipe = targetRecipe;
            }

            console.log("orderBillEntries - processed entry:", processedEntry);
            return processedEntry;
          });

          console.log("orderBillEntries result:", result);
          return result;
        } catch (error) {
          console.error("orderBillEntries error:", error);
          return [];
        }
      },
      set(newVal) {
        // Vue tarafından yapılan boş/reset atamalarını sessizce yut
        console.log("orderBillEntries setter ignored assignment:", newVal);
      }
    },

    hasTimeProducts() {
      return this.paymentGroups.some(group =>
        group.entries.some(entry => entry.isTime)
      );
    },

    hasRunningTimeProducts() {
      // Eğer hiç seçim yapılmamışsa tüm grupları kontrol et
      const groupsToCheck = this.selectedPaymentGroup.length > 0
        ? this.selectedPaymentGroup
        : this.paymentGroups;

      return groupsToCheck.some(group =>
        group.entries.some(entry => {
          if (!entry.isTime) return false;
          const stopDate = this.parseSafeDate(entry.lastStopTime);
          const hasStop = stopDate && stopDate.getFullYear() >= 2010;
          return entry.isRunning || !hasStop;
        })
      );
    },

    printerSettings() {

      return this.$store.getters["selfservice/getPrinterSettings"];

    },

    isLoading: {

      get() {

        return this.$store.getters["selfservice/getIsLoading"];

      },

      set(val) {

        this.$store.dispatch("selfservice/setIsLoading", val);

      },

    },

    isCakeQuestioned: {

      get() {

        return this.$store.getters["selfservice/getCakeQuestioned"];

      },

      set(val) {

        this.$store.dispatch("selfservice/setCakeQuestioned", val);

      },

    },



    discountPercentageText() {
      if (!this.orderPayments) return null;
      const percentageDiscounts = this.orderPayments.filter(p => p.paymentMethod && p.paymentMethod.id == 4 && p.unit == '%');
      if (percentageDiscounts.length > 0) {
        const uniqueValues = [...new Set(percentageDiscounts.map(p => p.value))];
        if (uniqueValues.length === 1) {
          return `%${uniqueValues[0]}`;
        } else {
          return `%...`;
        }
      }
      return null;
    },

    totalPaidAmount() {
      if (!this.orderPayments) return 0;
      return this.orderPayments.reduce((total, num) => {
        // v109: İndirim (4) ve Kampanya (15) dışındaki gerçek ödemeleri topla
        if (num.paymentMethod && (num.paymentMethod.id == 4 || num.paymentMethod.id == 15)) {
          return total;
        }
        return total + num.price;
      }, 0);
    },

    isActiveDiscount: {
      get() {
        return this.$refs.discount ? this.$refs.discount.isActive : false;
      },
      set(val) {
        if (this.hasRunningTimeProducts && val) {
          this.$vs.notify({
            color: "warning",
            title: "Uyarı",
            text: "Çalışan süreli ürün varken indirim uygulanamaz!",
          });
          return;
        }
        if (this.$refs.discount) {
          this.$refs.discount.isActive = val;
        }
      },
    },

    selectedPaymentMethod: {

      get() {

        return this.$store.getters["selfservice/getSelectedPaymentMethod"];

      },

      set(val) {

        if (val)

          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);

      },

    },

    paymentMethods: function () {

      return this.$store.getters["selfservice/getPaymentMethods"];

    },

    isReset: {

      get() {

        return this.$store.getters["selfservice/getToIsReset"];

      },

      set(val) {

        this.$store.dispatch("selfservice/setIsReset", val);

      },

    },

    totalOriginPrice: function () {

      return this.calculateTotalOriginPrice(this.paymentGroups);

    },

    totalPrice: function () {

      return this.calculateSelectedRemainingPrice(this.paymentGroups);

    },

    totalDiscountPrice: function () {
      const origin = parseFloat(this.totalOriginPrice) || 0;
      
      // 1. Sepet/Kampanya bazlı indirimler
      let basketDiscounts = (this.discounts || []).reduce((sum, d) => {
          let val = parseFloat(d.priceToDiscount || d.price || d.value || 0);
          if (!d.priceToDiscount && !d.price && (d.unit === '%' || d.unit === 1 || d.unit === "1")) {
              return sum + (origin * val / 100);
          }
          return sum + val;
      }, 0);

      // 2. Ödeme bazlı indirimler (id:4=İndirim, id:15=Kampanya)
      let logDiscounts = (this.orderPayments || []).reduce((sum, p) => {
          if (p.paymentMethod && (p.paymentMethod.id == 4 || p.paymentMethod.id == 15)) {
              let pVal = parseFloat(p.price || p.value || 0);
              if (pVal > 0 && !p.price && (p.unit === '%' || p.unit === 1 || p.unit === "1")) {
                  return sum + (origin * pVal / 100);
              }
              return sum + pVal;
          }
          return sum;
      }, 0);

      // 3. Ürün Bazlı İndirimler (OriginLineTotal - CurrentLineTotal)
      let campaignDiscounts = (this.paymentGroups || []).reduce(function (total, num) {
        let groupDiscount = (num.entries || []).reduce(function (entriesTotal, entry) {
          let originPriceRaw = parseFloat(entry.originPrice || entry.OriginPrice || 0);
          let currentPriceRaw = parseFloat(entry.price || entry.Price || 0);
          
          // v153: Original total must be at least as high as current total (handles unit vs total discrepancy)
          let originLineTotal = Math.max(originPriceRaw, currentPriceRaw);

          if (originLineTotal > currentPriceRaw) {
              return entriesTotal + (originLineTotal - currentPriceRaw);
          }
          return entriesTotal;
        }, 0);
        return total + groupDiscount;
      }, 0);

      return Math.round((basketDiscounts + logDiscounts + campaignDiscounts) * 100) / 100;
    },

    selectedGroupsPrice: function () {

      return this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);

    },

    currentCart: {

      get() {
        let cart = this.$store.getters["selfservice/getCurrentCart"];

        // FIX [v22]: Polling sırasında cart.active kaybolursa UUID bazlı geri yükle (Fallback)
        if (!cart && this.localBranchTableUId) {
           const allCarts = this.$store.getters["selfservice/getCarts"];
           cart = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
        }

        return cart;
      },

      set(payload) {

        this.$store.dispatch("selfService/setCurrentCartWithCampaign", payload);

      },

    },

    activePersonel:
    // function () {

    //   return this.$store.getters["selfservice/getActivePersonal"];
    {
      get() {
        var personal = this.$store.getters["selfservice/getActivePersonal"];

        // Eğer activePersonal null ise ve switch gizliyse, current user'ı kullan
        if (!personal) {
          var userInfo = JSON.parse(localStorage.getItem("userInfo"));

          if (userInfo) {
            this.$store.dispatch("selfservice/setActivePersonal", userInfo);
            return userInfo;
          }
        }
        return personal;
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
    // },

    toggleCalc: {
      get() {
        return this.isCalculatorPageActive;
      },
      set(val) {
        this.isCalculatorPageActive = val;
        this.$nextTick(() => {
          if (this.$refs.calculatorPage) {
            this.$refs.calculatorPage.isActive = val;
          }
        });
      },
    },

    sortedPaymentGroups() {
      if (!this.paymentGroups) return [];
      return [...this.paymentGroups].sort((a, b) => {
        // createdDate üzerinden sırala (en yeni en üstte)
        const dateA = (a.entries && a.entries[0] && a.entries[0].createdDate) ? new Date(a.entries[0].createdDate) : null;
        const dateB = (b.entries && b.entries[0] && b.entries[0].createdDate) ? new Date(b.entries[0].createdDate) : null;

        if (dateA && dateB) {
          return dateB - dateA;
        }
        
        // Tarih yoksa rowIndex (ID) üzerinden dene
        return b.rowIndex - a.rowIndex;
      });
    },

  },

  methods: {
    getPaymentMethodIdFromPosResponse(resultData, defaultId) {
      let posStatusId = defaultId;
      if (resultData && resultData.addedPayments && Array.isArray(resultData.addedPayments)) {
        let successfulPayments = resultData.addedPayments.filter(p => p.statusId === 2);
        if (successfulPayments.length > 0) {
          let addedPayment = successfulPayments[successfulPayments.length - 1];
          let paymentTypeId = addedPayment.paymentTypeId;
          let mediatorId = addedPayment.paymentMediatorId;
          
          if (paymentTypeId) {
            posStatusId = paymentTypeId;
          }
          
          if (addedPayment.isExternal) {
            let targetMethodName = "";
            
            // Standard PAVO Mediator ID / PaymentType ID mappings for External Payments:
            // 1/101 = Multinet
            // 2/102 = Sodexo
            // 3/103/13/26/113/126 = Ticket (Edenred / Ticket Gift)
            // 4/104 = Setcard
            // 5/105 = Metropol
            // 6/106 = TokenFlex
            if (mediatorId === 1 || mediatorId === 101 || paymentTypeId === 1 || paymentTypeId === 101) {
              targetMethodName = "Multinet";
            } else if (mediatorId === 2 || mediatorId === 102 || paymentTypeId === 2 || paymentTypeId === 102) {
              targetMethodName = "Sodexo";
            } else if (
              mediatorId === 3 || mediatorId === 103 || mediatorId === 13 || mediatorId === 26 || mediatorId === 113 || mediatorId === 126 ||
              paymentTypeId === 3 || paymentTypeId === 103 || paymentTypeId === 13 || paymentTypeId === 26 || paymentTypeId === 113 || paymentTypeId === 126
            ) {
              targetMethodName = "Ticket";
            } else if (mediatorId === 4 || mediatorId === 104 || paymentTypeId === 4 || paymentTypeId === 104) {
              targetMethodName = "Setcard";
            } else if (mediatorId === 5 || mediatorId === 105 || paymentTypeId === 5 || paymentTypeId === 105) {
              targetMethodName = "Metropol";
            } else if (mediatorId === 6 || mediatorId === 106 || paymentTypeId === 6 || paymentTypeId === 106) {
              targetMethodName = "TokenFlex";
            }
            
            if (targetMethodName) {
              let matchingMethod = this.paymentMethods.find(m => 
                (m.Name && m.Name.toLowerCase().includes(targetMethodName.toLowerCase())) ||
                (m.name && m.name.toLowerCase().includes(targetMethodName.toLowerCase()))
              );
              if (matchingMethod) {
                posStatusId = matchingMethod.id;
              }
            }
          }
        }
      }
      return posStatusId;
    },
    broadcastCartState() {
      try {
        const broadcaster = new BroadcastChannel('cart-channel');
        
        // Compile cart entries from active paymentGroups
        const cartEntries = [];
        if (this.isActive && this.paymentGroups) {
          this.paymentGroups.forEach(group => {
            if (group.entries && group.entries.length > 0) {
              group.entries.forEach(entry => {
                cartEntries.push({
                  id: entry.id,
                  productName: entry.productName,
                  quantity: entry.quantity || 1,
                  price: entry.price || 0,
                  extras: entry.extras || [],
                  recipe: entry.recipe || entry.Recipe || { steps: [] }
                });
              });
            }
          });
        }

        // Compile discounts from active orderPayments
        const discounts = [];
        if (this.isActive && this.orderPayments) {
          this.orderPayments.forEach(p => {
            if (p.paymentMethod && (p.paymentMethod.id === 4 || p.paymentMethod.id === 15)) {
              discounts.push({
                description: p.description || p.paymentMethod.name || 'İndirim',
                value: p.value || 0,
                unit: p.unit || '₺',
                discountAmount: p.price || p.value || 0
              });
            }
          });
        }

        broadcaster.postMessage({
          type: 'CART_UPDATE',
          data: {
            cartEntries: cartEntries,
            discounts: discounts
          }
        });
        broadcaster.close();
      } catch (err) {
        console.error("Error broadcasting cart state from OrderListPayment:", err);
      }
    },

    // v136: Tarih geçerliliğini kontrol et (0001-01-01 gibi hatalı değerleri yakalar)
    isValidDate(dateString) {
      if (!dateString) return false;
      const d = new Date(dateString);
      if (isNaN(d.getTime())) return false;
      // 2010 yılından öncesini hatalı kabul ediyoruz (Unix Epoch 1970'i de kapsar)
      return d.getFullYear() >= 2010;
    },

    // v138.7: Güvenli Tarih Ayrıştırıcı (ISO ve Türk formatlarını destekler)
    parseSafeDate(val) {
      if (!val) return new Date(0);
      if (val instanceof Date) return val;
      
      // Standart ISO kontrolü
      let d = new Date(val);
      if (!isNaN(d.getTime())) {
          // v138.8: Turkey Timezone Bug Fix
          // Eğer tarih "Z" ile bitiyorsa ve "now"dan 2 saatten fazla ilerideyse, 
          // muhtemelen yerel saat (UTC+3) yanlışlıkla Z ile işaretlenmiştir.
          const now = new Date();
          if (d.getTime() > now.getTime() + 3600000) {
              // 3 saat geri çek (Yerel saate dönüştür)
              d = new Date(d.getTime() - 3 * 3600000);
          }
          return d;
      }
      
      // Türk formatı kontrolü (GG.AA.YYYY SS:dd:ss)
      if (typeof val === "string" && val.includes(".")) {
          try {
              const parts = val.split(/[. :]/);
              if (parts.length >= 3) {
                  const day = parseInt(parts[0]);
                  const month = parseInt(parts[1]) - 1;
                  const year = parseInt(parts[2]);
                  const hour = parts[3] ? parseInt(parts[3]) : 0;
                  const min = parts[4] ? parseInt(parts[4]) : 0;
                  const sec = parts[5] ? parseInt(parts[5]) : 0;
                  return new Date(year, month, day, hour, min, sec);
              }
          } catch(e) { console.error("parseSafeDate fallback error", e); }
      }
      return new Date(0);
    },

    // v138.6: Virgül/Nokta ayrımı yapmadan sayıları güvenli parse et
    parseSafeNum(x) {
      if (typeof x === "number") return x;
      if (typeof x === "string") return parseFloat(x.replace(",", ".")) || 0;
      return Number(x) || 0;
    },

    // v138.9: Koşu ve Durma mantığını birbirinden ayır (Desktop)
    getSafeTotalMs(entry, overrideNow = null) {
      if (!entry) return 0;
      
      let totalMs = 0;
      const accumulatedHour = this.parseSafeNum(entry.totalHour);

      // EĞER KOŞUYORSA: Anlık süreyi hesapla + birikmiş süreyi ekle
      if (entry.isRunning) {
        const now = overrideNow || new Date();
        const start = entry.lastStartTime || entry.createdDate;
        const startTime = this.parseSafeDate(start);
        
        if (startTime.getFullYear() >= 2010) {
          const elapsed = now - startTime;
          // Makul süre kontrolü (0 - 1000 saat arası)
          if (elapsed > 0 && elapsed < 3600000000) {
            totalMs += elapsed;
          }
        }
        
        // Birikmiş saati ekle
        if (!isNaN(accumulatedHour) && accumulatedHour > 0) {
          totalMs += accumulatedHour * 3600000;
        }
      } 
      // EĞER DURMUŞSA: Sadece DB'deki totalHour değerine güven (Extra hesap yapma)
      else {
        if (!isNaN(accumulatedHour) && accumulatedHour > 0) {
          totalMs = accumulatedHour * 3600000;
        }
      }

      return Math.round(totalMs);
    },

    calculateTimeDuration(entry) {
      if (!entry || !entry.isTime) return '00:00:00';
      
      const totalMs = this.getSafeTotalMs(entry);

      const hours = Math.floor(totalMs / (1000 * 60 * 60));
      const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((totalMs % (1000 * 60)) / 1000);

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },

    // v138.1: Zaman aralığını formatla (Başlangıç - Bitiş (X dk))
    getDisplayTimeRange(entry) {
      if (!entry || !entry.isTime) return '';
      
      const start = this.isValidDate(entry.lastStartTime) ? entry.lastStartTime : entry.createdDate;
      const startTimeStr = start ? new Date(start).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }) : '--:--';
      
      let endTimeStr = '...';
      if (!entry.isRunning && this.isValidDate(entry.lastStopTime)) {
        endTimeStr = new Date(entry.lastStopTime).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
      } else if (entry.isRunning) {
        endTimeStr = 'Devam';
      }

      const totalMs = this.getSafeTotalMs(entry);
      const totalMinutes = Math.ceil(totalMs / 60000);

      return `${startTimeStr} - ${endTimeStr} (${totalMinutes} dk)`;
    },

    // Süreli ürün için anlık fiyat hesapla (sadece arayüz için)
    calculateCurrentPrice(paymentGroup) {
      if (!paymentGroup.entries || paymentGroup.entries.length === 0) {
        return paymentGroup.totalPrice;
      }

      const entry = paymentGroup.entries.find(e => e.isTime);

      // Süreli ürün değilse veya fiyat bilgisi yoksa mevcut fiyatı döndür
      if (!entry || !entry.hourPrice) {
        return paymentGroup.totalPrice;
      }

      const totalMs = this.getSafeTotalMs(entry);
      
      // Toplam süreyi dakikalar cinsinden hesapla (kesirli olabilir)
      const totalMinutes = totalMs / (1000 * 60);


      const pricePerMinute = entry.hourPrice / 60;

      // Toplam dakikayı yukarı yuvarlayarak (örneğin 7.5 dakika -> 8 dakika) dakika bazında yeni fiyatı hesapla
      const newPrice = Math.ceil(totalMinutes) * pricePerMinute;

      // Ödenen miktarı çıkararak kalan tutarı döndür
      return Math.max(0, newPrice - paymentGroup.payedPrice);
    },

    formatHours(totalHours) {
      if (!totalHours) return '00:00:00';

      const hours = Math.floor(totalHours);
      const minutes = Math.floor((totalHours - hours) * 60);
      const seconds = Math.floor(((totalHours - hours) * 60 - minutes) * 60);

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },

    async stopTimeProduct(paymentGroup, overrideStopTime = null, overrideStartTime = null) {
      try {
        const currentCart = JSON.parse(JSON.stringify(this.$store.getters["selfservice/getCurrentCart"]));
        if (!currentCart) return;

        const localEntry = paymentGroup.entries[0];
        const entry = currentCart.cartEntries.find(item => item.id === localEntry.id);
        if (!entry || !entry.isTime || !entry.isRunning) return;

        // Capture original values for logging
        const originalStart = entry.lastStartTime || entry.createdDate;
        const originalStartDate = this.parseSafeDate(originalStart);
        const originalStop = entry.lastStopTime;

        if (overrideStartTime) {
          if (entry.lastStartTime) {
            entry.lastStartTime = overrideStartTime.toISOString();
          } else {
            entry.createdDate = overrideStartTime.toISOString();
          }
          this.$set(localEntry, 'lastStartTime', entry.lastStartTime);
          this.$set(localEntry, 'createdDate', entry.createdDate);
        }

        const now = overrideStopTime || new Date();
        const totalMs = this.getSafeTotalMs(entry, now);

        // Toplam süreyi dakikalar cinsinden hesapla
        const totalMinutes = totalMs / (1000 * 60);


        // Toplam süreyi saat cinsinden güncelle
        entry.totalHour = totalMinutes / 60;
        entry.isRunning = false;
        entry.lastStopTime = now.toISOString();

        if (entry.hourPrice) {
          const pricePerMinute = entry.hourPrice / 60;
          const newPrice = Math.ceil(totalMinutes) * pricePerMinute;

          entry.price = newPrice;
          entry.originPrice = newPrice;
        }

        // v145 [Desktop]: Reactivity fix for payment buttons. use $set.
        this.$set(localEntry, 'totalHour', entry.totalHour);
        this.$set(localEntry, 'isRunning', false);
        this.$set(localEntry, 'lastStopTime', entry.lastStopTime);
        this.$set(localEntry, 'price', entry.price);
        this.$set(localEntry, 'originPrice', entry.originPrice);

        // Update cart total price on the clone
        currentCart.totalPrice = currentCart.cartEntries.reduce((total, e) => total + e.price, 0);

        // Dispatch update to store
        this.$store.dispatch('selfservice/updateCartsById', [currentCart]);

        // Payment group fiyatını yeniden hesapla
        this.reCalculatePaymentGroup();

        // Cart'ı sunucuya kaydet
        await this.saveCartToServer();

        // Log the time change action if it was an override
        if (overrideStartTime || overrideStopTime) {
          const formatTime = (d) => {
            if (!d) return "Devam Ediyor";
            const dateObj = new Date(d);
            if (isNaN(dateObj.getTime())) return d;
            const pad = (n) => n.toString().padStart(2, '0');
            const day = pad(dateObj.getDate());
            const month = pad(dateObj.getMonth() + 1);
            const year = dateObj.getFullYear();
            const hours = pad(dateObj.getHours());
            const minutes = pad(dateObj.getMinutes());
            return `${day}.${month}.${year} ${hours}:${minutes}`;
          };
          const originalStartStr = formatTime(originalStartDate);
          const originalStopStr = originalStop ? formatTime(originalStop) : "Devam Ediyor";
          const newStartStr = formatTime(overrideStartTime || originalStartDate);
          const newStopStr = formatTime(now);

          const systemLogDescription = `İşlem öncesi: Başlangıç: ${originalStartStr} - Bitiş: ${originalStopStr} | İşlem sonrası: Başlangıç: ${newStartStr} - Bitiş: ${newStopStr}`;

          await addDiscountLog({
            tableId: currentCart.tableId || 0,
            ids: [entry.id],
            totalDiscount: 0,
            discountType: "",
            actionType: "TimeChange",
            description: systemLogDescription,
            items: [entry]
          });
        }

        this.$vs.notify({
          color: "warning",
          title: "Süre Durduruldu",
          text: `${entry.productName} için süre durduruldu. Toplam: ${this.formatHours(entry.totalHour)}`,
        });
      } catch (err) {
        this.$vs.notify({ color: "danger", title: "Hata", text: err.toString() });
      }
    },

    // v138.2: Tüm çalışan süreleri tek seferde durdur
    async stopAllRunningTimeProducts() {
      try {
        this.isTransaction = true;
        this.isTimerActionInProgress = true; // Polling baskısını geçici olarak durdur

        const currentCart = JSON.parse(JSON.stringify(this.$store.getters["selfservice/getCurrentCart"]));
        if (!currentCart) {
          this.isTransaction = false;
          this.isTimerActionInProgress = false;
          return;
        }

        // Sepetteki tüm grupları kontrol et (seçimden bağımsız olarak çalışan tüm süreleri durdurmak için)
        const groupsToCheck = this.paymentGroups;

        let stoppedCount = 0;
        const now = new Date();

        groupsToCheck.forEach(group => {
            // Süreli ürünleri bul (bitiş tarihi girilmemiş veya isRunning = true olanlar)
            const timedEntries = group.entries.filter(e => {
              if (!e.isTime) return false;
              const stopDate = this.parseSafeDate(e.lastStopTime);
              const hasStop = stopDate && stopDate.getFullYear() >= 2010;
              return e.isRunning || !hasStop;
            });
            
            timedEntries.forEach(localEntry => {
              const cartEntry = currentCart.cartEntries.find(item => item.id === localEntry.id);
              if (cartEntry) {
                const stopDate = this.parseSafeDate(cartEntry.lastStopTime);
                const hasStop = stopDate && stopDate.getFullYear() >= 2010;

                if (cartEntry.isRunning || !hasStop) {
                  const totalMs = this.getSafeTotalMs(cartEntry, now);
                  const totalMinutes = totalMs / (1000 * 60);

                  console.log(`[TimerSTOP] Authoritative Stop -> Product: ${cartEntry.productName}, totalMs: ${totalMs}, totalMinutes: ${totalMinutes}`);
                  
                  // State update
                  this.$set(cartEntry, 'totalHour', totalMinutes / 60);
                  this.$set(cartEntry, 'isRunning', false);
                  this.$set(cartEntry, 'lastStopTime', now.toISOString());

                  if (cartEntry.hourPrice) {
                    const pricePerMinute = cartEntry.hourPrice / 60;
                    const finalPrice = Math.ceil(totalMinutes) * pricePerMinute;
                    cartEntry.price = finalPrice;
                    cartEntry.originPrice = finalPrice;
                  }

                  // Local UI state sync
                  this.$set(localEntry, 'totalHour', cartEntry.totalHour);
                  this.$set(localEntry, 'isRunning', false);
                  this.$set(localEntry, 'lastStopTime', cartEntry.lastStopTime);
                  this.$set(localEntry, 'price', cartEntry.price);
                  this.$set(localEntry, 'originPrice', cartEntry.originPrice);
                  
                  stoppedCount++;
                }
              }
            });
        });

        if (stoppedCount === 0) {
          this.isTransaction = false;
          this.isTimerActionInProgress = false;
          return;
        }

        currentCart.totalPrice = currentCart.cartEntries.reduce((total, e) => total + e.price, 0);
        await this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
        
        this.reCalculatePaymentGroup();
        await this.saveCartToServer();

        // 2 saniye sonra polling kilidini aç (Kaydın DB'de kesinleşmesi için süre tanı)
        setTimeout(() => {
          this.isTimerActionInProgress = false;
        }, 2000);

        this.$vs.notify({
          color: "success",
          title: "Süreler Durduruldu",
          text: `${stoppedCount} adet ürünün süresi başarıyla durduruldu ve fiyatlar güncellendi.`,
        });

        // v145 [Desktop]: Transaction kilidini işlem bittiğinde aç (Nakit/Kredi butonlarını aktif eder)
        this.isTransaction = false;

      } catch (err) {
        console.error("stopAllRunningTimeProducts error", err);
        this.isTimerActionInProgress = false;
        this.isTransaction = false;
        this.$vs.notify({ color: "danger", title: "Hata", text: err.toString() });
      }
    },

    async startTimeProduct(paymentGroup) {
      try {
        const currentCart = JSON.parse(JSON.stringify(this.$store.getters["selfservice/getCurrentCart"]));
        if (!currentCart) return;

        const localEntry = paymentGroup.entries[0];
        if (!localEntry.isTime || localEntry.isRunning) return;

        // Herhangi bir ödeme yapılmış süreli ürün tekrar başlatılamaz
        if (paymentGroup.payedPrice > 0) {
          this.$vs.notify({
            color: "warning",
            title: "Uyarı",
            text: "Ödeme yapılmış süreli ürün tekrar başlatılamaz!",
          });
          this.isTransaction = false;
          return;
        }

        const now = new Date();
        localEntry.isRunning = true;
        localEntry.lastStartTime = now.toISOString();

        // Find and update the corresponding entry in the cloned cart
        const cartEntry = currentCart.cartEntries.find(item => item.id === localEntry.id);
        if (cartEntry) {
          cartEntry.isRunning = true;
          cartEntry.lastStartTime = localEntry.lastStartTime;
        }

        // Dispatch update to store
        this.$store.dispatch('selfservice/updateCartsById', [currentCart]);

        // Payment group fiyatını yeniden hesapla
        this.reCalculatePaymentGroup();

        // Cart'ı sunucuya kaydet
        await this.saveCartToServer();

        this.$vs.notify({
          color: "success",
          title: "Süre Başlatıldı",
          text: `${localEntry.productName} için süre başlatıldı.`,
        });
      } catch (err) {
        this.$vs.notify({ color: "danger", title: "Hata", text: err.toString() });
      }
    },

    mergeSelectedProducts() {

      if (this.selectedPaymentGroup.length <= 1) {

        this.$vs.notify({

          color: "warning",

          title: "Uyarı",

          text: "Birleştirilecek en az 2 ürün seçmelisiniz.",

        });

        return;

      }



      // Seçilen grupları sakla ve ödenen tutarı hesapla

      this.selectedGroupsForMerge = [...this.selectedPaymentGroup];

      this.totalPayedPriceForMerge = 0;

      this.selectedGroupsForMerge.forEach((group) => {

        this.totalPayedPriceForMerge += group.payedPrice || 0;

      });



      // Modal aç ve input temizle

      this.newMergePrice = "";

      this.isMergeModalOpen = true;



      // Input'a focus ver

      this.$nextTick(() => {

        if (this.$refs.txtMergePrice) {

          this.$refs.txtMergePrice.focus();

        }

      });

    },

    appendToPrice(value) {

      // Eğer nokta ekleniyor ve zaten nokta varsa, ekleme

      if (value === '.' && this.newMergePrice.includes('.')) {

        return;

      }



      // Nokta sonrası en fazla 2 basamak

      if (this.newMergePrice.includes('.')) {

        const decimalPart = this.newMergePrice.split('.')[1];

        if (decimalPart && decimalPart.length >= 2 && value !== '.') {

          return;

        }

      }



      this.newMergePrice += value;

    },

    clearPrice() {

      if (this.newMergePrice.length > 0) {

        this.newMergePrice = this.newMergePrice.slice(0, -1);

      }

    },

    confirmMergeFromModal() {

      const newPrice = parseFloat(this.newMergePrice);



      if (!newPrice || newPrice <= 0) {

        this.$vs.notify({

          color: "warning",

          title: "Uyarı",

          text: "Geçerli bir fiyat giriniz.",

        });

        return;

      }



      if (newPrice < this.totalPayedPriceForMerge) {

        this.$vs.notify({

          color: "warning",

          title: "Uyarı",

          text: `Yeni fiyat en az ${this.$toCurrency(this.totalPayedPriceForMerge)} olmalıdır (ödenen tutar).`,

        });

        return;

      }



      // Modal kapat

      this.isMergeModalOpen = false;

      this.newMergePrice = "";



      // Birleştirme işlemini yap

      this.confirmMerge(newPrice);

    },

    cancelMerge() {

      this.isMergeModalOpen = false;

      this.newMergePrice = "";

      this.selectedGroupsForMerge = [];

      this.totalPayedPriceForMerge = 0;

    },

    confirmMerge(newPrice) {

      // Seçilen grupların verilerini hesapla

      var totalOriginalPrice = 0;

      var totalPayedPrice = 0;

      this.selectedGroupsForMerge.forEach((group) => {

        totalOriginalPrice += group.totalPrice || 0;

        totalPayedPrice += group.payedPrice || 0;

      });



      // Fiyat farkını hesapla

      const priceDifference = totalOriginalPrice - newPrice;



      // Yeni birleştirilmiş grup oluştur

      var mergedGroup = {

        rowIndex: uuid.v1(),

        entries: [],

        totalPrice: newPrice,

        payedPrice: totalPayedPrice,

        status: "Kalan",

      };



      // Tüm entry'leri birleştir

      this.selectedGroupsForMerge.forEach((group) => {

        mergedGroup.entries = mergedGroup.entries.concat(group.entries);

      });



      // Entry fiyatlarını ayarla (ilk entry'ye tüm fiyat, diğerleri 0)

      if (mergedGroup.entries.length > 0) {

        mergedGroup.entries[0].price = newPrice;

        for (var i = 1; i < mergedGroup.entries.length; i++) {

          mergedGroup.entries[i].price = 0;

        }

      }



      // Seçilen grupları kaldır ve yeni grubu ekle

      var remainingGroups = this.paymentGroups.filter((group) =>

        !this.selectedGroupsForMerge.some((selected) => selected.rowIndex === group.rowIndex)

      );

      remainingGroups.push(mergedGroup);

      this.paymentGroups = remainingGroups;



      // Eğer fiyat indirimi varsa, Kampanya ödeme yöntemi olarak ekle

      if (priceDifference > 0) {

        var campaignPayment = {

          id: uuid.v1(),

          paymentMethod: {

            id: 15, // Kampanya payment method ID'si

            name: "Kampanya"

          },

          price: priceDifference,

          value: priceDifference,

          unit: "₺",

          description: "Ürün Birleştirme İndirimi",

          discountDescription: `${this.$toCurrency(totalOriginalPrice)} → ${this.$toCurrency(newPrice)}`,

        };

        this.orderPayments.push(campaignPayment);

      }



      // Seçimi temizle

      this.selectedPaymentGroup = [];

      this.selectedGroupsForMerge = [];

      this.totalPayedPriceForMerge = 0;



      // Fiyatları yeniden hesapla

      this.reCalculatePaymentGroup();



      // Cart'ı sunucuya kaydet

      this.saveCartToServer();



      this.$vs.notify({

        color: "success",

        title: "Başarılı",

        text: `Seçilen ürünler ${this.$toCurrency(newPrice)} fiyatı ile birleştirildi.`,

      });

    },

    async saveCartToServer() {
      try {
        var cart = _.cloneDeep(this.$store.getters["selfservice/getCurrentCart"]);
        if (!cart) return;

        cart.paymentGroups = _.cloneDeep(this.paymentGroups);
        cart.orderPayments = _.cloneDeep(this.orderPayments);
        cart.discounts = _.cloneDeep(this.discounts);
        
        // Bakiyeyi her zaman güncel tut ki masa kapanma sorunu yaşanmasın
        cart.totalPayedPrice = cart.orderPayments.reduce((total, p) => total + (parseFloat(p.price) || 0), 0);
        cart.remainingAmount = Math.round((cart.totalPrice - cart.totalPayedPrice) * 100) / 100;

        const saveRes = await setBranchCart({ value: cart, tableId: cart.tableId, branchTableUId: cart.branchTableUId });
        
        // CRITICAL [v25]: RowVersion sync
        if (saveRes && saveRes.data && saveRes.data.rowVersion) {
            this.currentCart.rowVersion = saveRes.data.rowVersion;
            console.log("Safe Version Sync: RowVersion güncellendi.", saveRes.data.rowVersion);
        }
      } catch (error) {
        console.error("Cart kaydedilemedi:", error);
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Değişiklikler sunucuya kaydedilemedi.",
        });
      }
    },

    showPaymentScreen(branchTableUId, branchId) {
      // ARMOR [v26]: Eğer dışarıdan null gelirse Store'dan son bir kez kurtarmayı dene
      if (!branchTableUId) {
          const storeCart = this.$store.getters['selfservice/getCurrentCart'];
          if (storeCart && storeCart.branchTableUId) {
              branchTableUId = storeCart.branchTableUId;
              console.log("[ARMOR v26] Recovery: branchTableUId recovered from Store:", branchTableUId);
          }
      }

      if (branchTableUId) {
          this.localBranchTableUId = branchTableUId;
          console.log("showPaymentScreen: Setting localBranchTableUId (anchor):", branchTableUId);
      }
      
      if (branchId) {
          this.localBranchId = branchId;
      }
      this.isActive = true;
    },

    closePaymentScreen() {

      this.isActive = false;

      this.$emit('close');

    },

    printBill() {

      this.isPrinting = true;

      const rowIndexes = this.selectedPaymentGroup.map(selected => selected.rowIndex);

      console.log("printBill", rowIndexes);

      this.$emit("printBill", rowIndexes, this.printCopyCount);




      // Simulate print delay and reset loading state

      setTimeout(() => {

        this.isPrinting = false;

      }, 2000);

    },

    async loadKitchens() {
      try {
        const res = await getAllKitchen();
        this.kitchens = res.data || [];
      } catch (err) {
        console.error("OrderListPayment: Kitchens load failed:", err);
      }
    },
    changeCart(newCart) {
    if (!newCart || !this.currentCart || newCart.id != this.currentCart.id) return;
    if (this.isTransaction) return;

    this.isTransaction = true; 
    this.paymentGroups = newCart.paymentGroups;
    this.orderPayments = newCart.orderPayments;
    this.selectedPaymentGroup = [];
    this.generatePaymentGroups();

    this.$nextTick(() => {
      this.isTransaction = false; 
    });
    },

    checkScreen() {

      this.isMobile = window.innerWidth <= 768;

    },

    commitQrCode(customer) {

      this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);

    },

    getTotalGift(row) {

      var totalGift = row.entries.reduce(function (total, num) {

        if (num.originPrice - num.price > 0)

          return total + (num.originPrice - num.price);

        else return total + 0;

      }, 0);

      return this.$toCurrency(totalGift);

    },

    breakToRow: async function () {

      console.log("breakToRow", this.selectedPaymentGroup);

      var currentCart = {

        ...this.$store.getters["selfservice/getCurrentCart"],

      };

      var selectedSinglePaymentGroup = this.selectedPaymentGroup[0];

      var breakResult = await breakToRow(selectedSinglePaymentGroup.rowIndex, currentCart.tableId);

      console.log("breakResult", breakResult.data);

      this.paymentGroups = breakResult.data.paymentGroups;

      this.selectedPaymentGroup = [];

      this.generatePaymentGroups();



      // const asyncRemovedItems = this.selectedPaymentGroup

      //     .filter((selected) => selected.rowIndex)

      //     .map(

      //       (selected) => () =>

      //         breakToRow(selected.rowIndex, currentCart.tableId)

      //     );

      //   for await (var item of asyncRemovedItems) {

      //     await item();

      //   }

    },
    showDescriptionPrompt(text, callback) {
      this.descriptionPromptText = text;
      this.descriptionPromptCallback = callback;
      this.pendingDescription = "";
      this.isDescriptionPromptActive = true;
    },
    async confirmDescriptionPrompt() {
      if (this.pendingDescription && this.pendingDescription.trim() !== "") {
        if (this.descriptionPromptCallback) {
          await this.descriptionPromptCallback(this.pendingDescription);
        }
        this.isDescriptionPromptActive = false;
        this.pendingDescription = "";
        this.descriptionPromptCallback = null;
      }
    },
    cancelDescriptionPrompt() {
      this.isDescriptionPromptActive = false;
      this.pendingDescription = "";
      this.descriptionPromptCallback = null;
    },
    ClearCart: async function () {
      if(!this.currentCart) return;
      if (this.selectedPaymentGroup.length === 0) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Lütfen silinecek ürünleri seçiniz.",
        });
        return;
      }

      // v118.V35 [SAFETY]: Ödeme veya İndirim yapılmış kalemlerin silinmesini engelle
      const blockedItems = this.selectedPaymentGroup.filter(item => {
        const itemPrice = (parseFloat(item.totalPrice) || 0);
        if (itemPrice > 0) {
          // Sadece fiyatı > 0 olan ürünler için ödeme veya indirim kontrolü yap
          const hasPayment = (parseFloat(item.payedPrice) || 0) > 0;
          const hasDiscount = item.entries && item.entries.some(entry => 
            (parseFloat(entry.originPrice) || parseFloat(entry.price) || 0) > (parseFloat(entry.price) || 0)
          );
          return hasPayment || hasDiscount;
        }
        // Fiyatı 0 olan ürünler her zaman silinebilir
        return false;
      });

      if (blockedItems.length > 0) {
        this.$vs.notify({
          color: "warning",
          title: "İşlem Engellendi",
          text: "Ödeme yapılmış veya indirim uygulanmış ürünler silinemez.",
        });
        return;
      }

      this.showDescriptionPrompt("Seçili ürünleri silmek için lütfen bir açıklama giriniz.", async (description) => {
        // FIX [400/422 Error]: Görünen masa no (558) yerine veritabanı ID'sini (Numeric) kullan
        const cart = this.currentCart || {};
        const targetTableId = cart.branchTableId || cart.realId || ( (!isNaN(cart.id) && cart.id > 1000) ? cart.id : cart.tableId );
        const targetCartId = cart.id || null;
        
        console.log(`[v400-FIX] ClearCart targeting TableID: ${targetTableId} (Display/UI: ${cart.tableId})`);
        
        const selectedGroupSnapshot = _.cloneDeep(this.selectedPaymentGroup || []);
        const deletedEntries = selectedGroupSnapshot.flatMap(pg => pg.entries || []);
        const selectedRowIndexes = selectedGroupSnapshot.map(x => x.rowIndex);
        
        if (!targetTableId) {
           this.isLoading = false;
           this.$vs.notify({ color: "danger", title: "Hata", text: "Masa bilgisi alınamadı." });
           return;
        }

        try {
          this.isLoading = true;

          // 1. Store'dan sil
          this.$store.dispatch(
            "selfservice/removeEntryFromCurrentCart",
            selectedGroupSnapshot
          );

          this.$store.dispatch("selfservice/setToUpdateEntry", null);

          // 2. Yerel paymentGroups'u güncelle (Arayüzde anlık kaybolsun)
          this.paymentGroups = (this.paymentGroups || []).filter(
            (pg) => !selectedRowIndexes.includes(pg.rowIndex)
          );

          // 3. API çağrısı yap - FIX [400 Error]: rowIndex yerine gerçek entry.id'leri gönder
          const entryIdsToDelete = deletedEntries.map(e => e.id).filter(id => id != null);
          
          let result;
          try {
             result = await removeToCartIds(entryIdsToDelete, targetTableId, description);
          } catch(apiErr) {
             console.warn("[v400-FIX] removeToCartIds ucu HATA verdi (Muhtemelen Lock Hatası). Single remove ucuyla deneniyor...", apiErr);
             for(const eId of entryIdsToDelete) {
                // await removeToCart(eId, targetTableId, description || " "); // removeToCart OrderListPayment içinde import edilmemiş olabilir. 
             }
             // Asıl hata place-order'dan kaynaklandığı için ve backend kilit kontrolü olduğu için doğrudan hatayı fırlat.
             throw apiErr;
          }
          if (result) {
            // 4. Sepetleri tazele...
            // ... (rest is same)
            // 4. Sepetleri tazele
            var cartsResponse = await getCarts();
            var carts = cartsResponse.data || [];

            this.$store.dispatch(
              "selfservice/setToCart",
              carts.map((cart) => ({
                ...cart,
                active: cart.tableId == targetTableId,
              }))
            );

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Seçili ürünler sepetten silindi.",
            });

            // 5. İPTAL FİŞİ (CANCELLATION PRINT) - Korumalı blok
            try {
              if (deletedEntries.length > 0 && (targetTableId || targetCartId)) {
                  const sidToPrint = this.localBranchTableUId || targetTableId || targetCartId;
                  const finalTableName = this.tableName || "Masa";

                  const uniquePrinters = new Set();
                  deletedEntries.forEach(entry => {
                    const kitchen = (this.kitchens || []).find(k => k.id === entry.kitchenId);
                    const pName = (kitchen && (kitchen.printerName || kitchen.PrinterName)) ? (kitchen.printerName || kitchen.PrinterName) : "Mutfak";
                    uniquePrinters.add(pName);
                  });

                  if (uniquePrinters.size === 0) uniquePrinters.add("Mutfak");

                  uniquePrinters.forEach(printer => {
                    triggerKitchenPrintBySID(sidToPrint, printer, finalTableName, false)
                      .then(res => console.log(`[v125] Cancellation Print Sent:`, res))
                      .catch(err => console.error(`[v125] Cancellation Print Failed:`, err));
                  });
              }
            } catch (printErr) {
               console.warn("Kitchen print logic failed but cart flow continues:", printErr);
            }

            // 6. Sepet boşaldıysa ve ödeme kaydı yoksa masayı otomatik sıfırla ve kapat (Kullanıcı kuralı)
            const updatedCart = carts.find(c => c.tableId == targetTableId);
            if (!updatedCart || !updatedCart.cartEntries || updatedCart.cartEntries.length == 0) {
              
              // Sadece ÖDEME KAYDI YOKSA masayı sıfırla ve pencereyi kapat
              if ((this.orderPayments || []).length == 0) {
                this.isCakeQuestioned = false;
                
                if (this.isTableMode && targetTableId) {
                  try {
                    await unReserveTable(targetTableId);
                  } catch (reserveErr) {
                    console.warn("Table unreserve failed (already empty?):", reserveErr);
                  }
                }
                
                this.$store.dispatch("selfservice/removeCart", targetCartId);
                this.selectedPaymentGroup = [];
                this.paymentGroups = [];
                this.$emit("switchToTableMap");
                this.isActive = false; // Pencereyi kapat
              } else {
                this.initValues();
              }
            } else {
              this.initValues();
            }
          }
        } catch (error) {
          console.error("[v400-DEBUG] ClearCart error full:", error);
          if (error.response && error.response.data) {
             console.error("[v400-DEBUG] API error response data:", error.response.data);
             if (error.response.data.Message || error.response.data.message) {
                this.$vs.notify({ color: "danger", title: "İşlem Reddedildi", text: error.response.data.Message || error.response.data.message , time: 6000 });
             } else {
                this.$vs.notify({ color: "danger", title: "API Hatası", text: JSON.stringify(error.response.data) , time: 6000 });
             }
          }
          this.isLoading = false;
        } finally {
          this.isLoading = false;
        }
      });
    },
    initValues() {
      this.selectedGift = null;
      this.orderPayments = _.cloneDeep(this.currentCart.orderPayments || []);
      this.paymentGroups = _.cloneDeep(
        this.currentCart.paymentGroups != null
          ? this.currentCart.paymentGroups
          : []
      );
      this.selectedPaymentGroup = [];
      // eslint-disable-next-line no-undef
      this.cloneCurrentCart = _.cloneDeep(this.currentCart);
      this.localMergedIds = (this.currentCart && this.currentCart.mergedIds) ? [...this.currentCart.mergedIds] : [];
      this.generatePaymentGroups();
      this.$nextTick(() => {
        this.isTransaction = false;
      });
      this.$nextTick(() => {
        const remaining = this.calculateSelectedRemainingPrice(this.paymentGroups);
        if (remaining <= 0 && this.isActive && !this.isTransaction) {
          if (this.currentCart && this.currentCart.cartEntries && this.currentCart.cartEntries.length > 0) {
             console.log("initValues: Auto-committing iptal edildi (0 TL kilit hatasindan dolayi). Kapat/Ode butonuna basilmasi beklenecek.");
             this.isCommitable = true;
             // this.createCommitModel(); // [v422-FIX] Otomatik commit backend'de kilit (422) veya cift istek yaratabiliyor.
          }
        } else if (remaining > 0) {
          this.isCommitable = false;
        }
      });
    },

    generatePaymentGroups() {
      if (!this.currentCart || !this.currentCart.cartEntries) return;
      // this.paymentGroups.length = 0;
      this.currentCart.cartEntries.forEach((entry) => {
        if (!this.paymentGroups.some((group) => group.rowIndex === entry.id)) {
          var tempPaymentGroup = {
            rowIndex: entry.id,
            entries: [],
            totalPrice: 0,
            payedPrice: 0,
            status: "Kalan",
          };
          tempPaymentGroup.rowIndex = entry.id;
          tempPaymentGroup.entries.push(_.cloneDeep(entry));
          tempPaymentGroup.totalPrice = entry.price;
          tempPaymentGroup.payedPrice = 0;
          tempPaymentGroup.status = "Kalan";
          this.paymentGroups.push(tempPaymentGroup);
        }
      });
      this.reCalculatePaymentGroup();
    },

    initGifts() {
      if (!this.currentCart || !this.currentCart.cartEntries) return;
      if (this.currentCart.customer) {
        var cart = this.currentCart;
        cart.cartEntries.forEach((x) => {
          if (x.categories && x.categories.length > 0) {
            x.categoryId = x.categories[0].id;
          }
        });
        var payments = this.orderPayments;
        var orderModel = {
          id: cart.id,
          customerId: cart.customer ? cart.customer.id : null,
          qrCode: cart.customer ? cart.customer.giftQrCode : null,
          totalPrice: cart.totalPrice,
          active: cart.active,
          cartEntries: [...cart.cartEntries],
          branchName: this.$currentUser.branch.name,
          paymentInformations: [...payments],
          userName: this.activePersonel ? this.activePersonel.name : "",
          userId: this.activePersonel ? this.activePersonel.id : null,
        };
        FindAvailableCampaigns(orderModel)
          .then((res) => {
            if (res && res.status == 200) {
              if (res.data.isValid) {
                let clonedCart = Object.assign({}, this.currentCart);
                clonedCart.cartEntries = res.data.newEntries;
                if (res.data.customerGiftId != null)
                  clonedCart.customerGiftId = res.data.customerGiftId;
                else if (res.data.campaignGiftId != null)
                  clonedCart.campaignGiftId = res.data.campaignGiftId;
                this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
                this.generatePaymentGroups();
              }
            } else {
              this.$fire({
                title: "Hata : " + res.status,
                text: "Kampanyalara Erişilemedi !",
                type: "error",
              });
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Kampanyalara Erişilemedi !",
              });
            }
          })
          .catch(() => {

            this.$fire({

              title: "Hata !",

              text: "Sunucu Bağlantı Hatası !",

              type: "error",

            });

            this.$vs.notify({

              color: "danger",

              title: "Hata !",

              text: "Sunucu Bağlantı Hatası !",

            });

          });

      }

    },
    
    openDiscountModal() {
      if (!this.currentCart) return;
      this.$refs.discount.isActive = true;
    },

    async resetDiscount() {
      try {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: "İndirim Sıfırla",
          text: "Uygulanan tüm indirimleri sıfırlamak istediğinize emin misiniz?",
          acceptText: "Evet",
          cancelText: "Vazgeç",
          accept: async () => {
            this.isLoading = true;
            this.isTransaction = true;

            const currentCartData = this.$store.getters["selfservice/getCurrentCart"];
            if (!currentCartData) return;
            const currentCart = JSON.parse(JSON.stringify(currentCartData));

            // 1. İndirimli ödemeleri ve kampanyaları temizle
            this.orderPayments = this.orderPayments.filter(p => p.paymentMethod && p.paymentMethod.id != 4 && p.paymentMethod.id != 15);
            this.discounts = [];
            currentCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
            currentCart.discounts = [];
            currentCart.totalPayedPrice = 0;
            currentCart.campaignGiftId = null;
            currentCart.customerGiftId = null;

            // 2. Ürün fiyatlarını orijinal haline döndür
            currentCart.cartEntries.forEach(entry => {
              // v153: Restore to original, but ensure it doesn't drop below the line current if origin is just a unit price
              entry.price = Math.max(parseFloat(entry.originPrice || 0), parseFloat(entry.price || 0));
            });

            // 3. PaymentGroups'u TAMAMEN tazele (Desync önlemek için)
            // Local state'i de temizleyip cartEntries üzerinden yeniden inşa ediyoruz
            this.paymentGroups = [];
            currentCart.cartEntries.forEach((entry) => {
              let tempPaymentGroup = {
                rowIndex: entry.id,
                entries: [JSON.parse(JSON.stringify(entry))],
                totalPrice: entry.price,
                payedPrice: 0,
                status: "Kalan",
              };
              this.paymentGroups.push(tempPaymentGroup);
            });

            // 4. Tutarları güncelle
            currentCart.totalPrice = currentCart.cartEntries.reduce((total, e) => total + (parseFloat(e.price) || 0), 0);
            currentCart.totalPrice = Math.round(currentCart.totalPrice * 100) / 100;
            currentCart.remainingAmount = currentCart.totalPrice;
            currentCart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
            
            // Store güncelle ve reaktiviteyi sağla
            await this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
            this.reCalculatePaymentGroup();
            
            // 5. Sunucuya kaydet
            await setBranchCart({ 
              value: currentCart, 
              tableId: currentCart.tableId, 
              branchTableUId: currentCart.branchTableUId 
            });

            // 6. Log StaffAction (İndirim İptal)
            try {
              if (currentCart && currentCart.cartEntries) {
                const logIds = currentCart.cartEntries.map(e => e.id);
                await addDiscountLog({
                  tableId: currentCart.id,
                  branchTableUId: currentCart.branchTableUId,
                  branchId: currentCart.branchId,
                  ids: logIds,
                  totalDiscount: 0,
                  discountType: "Discount",
                  actionType: "Reset",
                  description: "İndirim İptal"
                });
                console.log("Discount Reset Log Success");
              }
            } catch (logErr) {
              console.error("Discount Reset Log Error:", logErr);
            }

            this.isLoading = false;
            this.isTransaction = false;

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Tüm indirimler ve kampanyalar sıfırlandı.",
            });
          }
        });
      } catch (err) {
        console.error("resetDiscount error:", err);
        this.isLoading = false;
        this.isTransaction = false;
        this.$vs.notify({ color: "danger", title: "Hata", text: err.toString() });
      }
    },

    async appendDiscount(discountObj) {
      try {
        this.isTransaction = true;
        // Eğer kalem seçili değilse tüm kalemleri baz al
        let targetGroups = (this.selectedPaymentGroup && this.selectedPaymentGroup.length > 0) 
          ? this.selectedPaymentGroup 
          : this.paymentGroups;

        // Tüm girişlerin ID'lerini topla (kalem bazlı indirim için)
        let logIds = [];
        targetGroups.forEach(group => {
          if (group.entries && group.entries.length > 0) {
            group.entries.forEach(entry => {
              logIds.push(entry.id);
            });
          }
        });

        // İndirim log kaydı için backend API'sini çağır
        try {
          const currentTableUUID = (this.currentCart && this.currentCart.branchTableUId) ? this.currentCart.branchTableUId : this.localBranchTableUId;
          const currentBranchId = this.localBranchId || (this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null);
          
          await addDiscountLog({
            tableId: (this.currentCart ? this.currentCart.id : null),
            branchTableUId: currentTableUUID,
            branchId: currentBranchId,
            ids: logIds,
            totalDiscount: discountObj.priceToDiscount,
            discountType: "Discount",
            actionType: "Discount",
            description: discountObj.description
          });
          
          if (currentTableUUID) {
            // UUID üzerinden en taze veriyi çekip versiyonu senkronize edelim
            const allCarts = this.$store.getters["selfservice/getCarts"];
            const targetCart = allCarts.find(c => c && c.branchTableUId == currentTableUUID);
            if (targetCart) {
                let res = await getOrderEntries(targetCart.id);
                if (res && res.data && res.data.rowVersion) {
                    targetCart.rowVersion = res.data.rowVersion;
                    console.log("Discount Version Sync: RowVersion güncellendi (UUID tabanlı).");
                }
            }
          }
        } catch (logError) {
          console.error("Discount log error (atomic refresh):", logError);
        }

        this.paymentDiscount = {
          paymentMethod: this.selectedPaymentMethod,
          value: discountObj.value,
          description: discountObj.description,
          unit: discountObj.unit,
          selectedPaymentGroup: logIds,
          payedPrice: discountObj.payedPrice,
          discountDescription: discountObj.discountDescription,
        };

        var selectedMethodTemp = this.selectedPaymentMethod;
        this.selectedPaymentMethod = this.$store.getters["selfservice/getPaymentMethods"].find((x) => x.id == 4);

        if (!this.selectedPaymentMethod) {
            this.selectedPaymentMethod = { id: 4, name: "İndirim" };
        }

        // doPay'den önce listeye ekle ki doPay içindeki clone işleminde bu indirim de gitsin
        this.discounts.push(this.paymentDiscount);

        await this.doPayWithoutPos(discountObj.priceToDiscount, true);
        
        this.selectedPaymentMethod = selectedMethodTemp;

      } catch (err) {
        console.error("appendDiscount error:", err);
      } finally {
        this.paymentDiscount = {};
      }
    },

    returnSelectedExtraVariant(extra) {

      var returnObj = [];

      extra.variants.forEach((x) => {

        if (x.quantity > 0) {

          returnObj.push("x" + x.quantity + " / " + x.name);

        }

      });

      return returnObj.length > 0 ? returnObj : null;

    },

    createCommitModel: async function () {
      console.log("createCommitModel - ARMED AND STARTING");
      
      // 0. SEPET KURTARMA (RECOVERY) - Polling sırasında null gelirse store'dan UUID bazlı geri al
      let cartSnapshot = this.currentCart ? JSON.parse(JSON.stringify(this.currentCart)) : null;
      if (!cartSnapshot && this.localBranchTableUId) {
          console.warn("createCommitModel (Early Recovery): currentCart is NULL, attempting to recover by UUID (anchor):", this.localBranchTableUId);
          const allCarts = this.$store.getters["selfservice/getCarts"];
          const recovered = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
          if (recovered) {
              cartSnapshot = JSON.parse(JSON.stringify(recovered));
              cartSnapshot.active = true; 
              console.log("createCommitModel: Cart recovered successfully by UUID.");
          }
      }

      // 1. GÜVENLİK KONTROLLERİ
      if (!cartSnapshot || !cartSnapshot.cartEntries || cartSnapshot.cartEntries.length === 0) {
        console.warn("createCommitModel: Sipariş kalemleri boş görünüyor, ancak ödeme grupları kontrol ediliyor.");
        if (Math.round((cartSnapshot ? cartSnapshot.totalPrice : this.totalOriginPrice) * 100) <= 0) {
           console.error("createCommitModel: Gerçekten boş sepet. İptal.");
           return;
        }
      }
      
      if (Math.round(this.totalOriginPrice * 100) < 0) {
        console.warn("createCommitModel: Sipariş toplam tutarı negatif, işlem iptal edildi.");
        return;
      }

      if (this.isTransaction) {
         console.warn("createCommitModel: İşlem zaten devam ediyor.");
         return;
      }
      
      // Idempotency: İşlem bazlı benzersiz anahtar oluşturma
      if (!this.submissionId) {
        this.submissionId = "sub_" + Date.now() + "_" + Math.random().toString(36).substring(7);
        console.log("createCommitModel: Yeni SubmissionId oluşturuldu:", this.submissionId);
      } else {
        console.log("createCommitModel: Mevcut SubmissionId kullanılıyor (Retry):", this.submissionId);
      }
      
      this.isTransaction = true;

      // 2. VERİ SNAPSHOTLARI (Ekran kapanmadan önce verileri dondur)
      this.snapshotTotalOriginPrice = this.totalOriginPrice;
      this.snapshotTotalDiscountPrice = this.totalDiscountPrice;
      this.snapshotTableName = this.tableName || (this.currentCart ? this.currentCart.name : '');
      
      // 3. YAZDIRMA Öncesi Snapshot (v20)
      let cartItemsForPrint = [];
      if (this.paymentGroups && this.paymentGroups.length > 0) {
        this.paymentGroups.forEach(group => {
           if (group.entries && group.entries.length > 0) {
             group.entries.forEach(entry => {
               if (entry) {
                 cartItemsForPrint.push(JSON.parse(JSON.stringify(entry)));
               }
             });
           }
        });
      }
      this.snapshotBillEntries = cartItemsForPrint;
      
      // 4. ARAYÜZÜ Kapatmayı Erteliyoruz
      this.isCommitable = false;
      this.isDiscountPaymentPopupActive = false;

        // 5. BACKEND İŞLEMİ
        try {
          this.isLoading = true;
  
          let synchronizedEntries = [];
          if (this.paymentGroups && this.paymentGroups.length > 0) {
            this.paymentGroups.forEach(group => {
              if (group.entries && group.entries.length > 0) {
                group.entries.forEach(entry => {
                  synchronizedEntries.push(entry);
                });
              }
            });
          }

          if (this.isTableMode && cartSnapshot && cartSnapshot.id) {
              try {
                  const latestCartRes = await getOrderEntries(cartSnapshot.id);
                  if (latestCartRes && latestCartRes.data) {
                      if (latestCartRes.data.rowVersion) {
                          cartSnapshot.rowVersion = latestCartRes.data.rowVersion;
                          console.log("[v29-OrderListPayment] RowVersion updated from Cart API:", cartSnapshot.rowVersion);
                      } else {
                          console.warn("[v29-OrderListPayment] Cart API returned NULL rowVersion, attempting Master Sync...");
                          try {
                              // [v37-OMEGA-RESERVE] Force wake-up call to the server
                              console.log("[v37-OMEGA-RESERVE] Forcing server-side table reservation for:", cartSnapshot.tableId);
                              try {
                                  await reserveTable(cartSnapshot.tableId);
                                  const freshCartsRes = await getCarts();
                                  if (freshCartsRes && freshCartsRes.data) {
                                      this.$store.dispatch("selfservice/setToCart", freshCartsRes.data);
                                      // Find our table in the fresh list
                                      const serverCart = freshCartsRes.data.find(c => c && c.tableId == cartSnapshot.tableId);
                                       if (serverCart) {
                                          cartSnapshot.rowVersion = serverCart.rowVersion;
                                          cartSnapshot.id = serverCart.id;
                                          cartSnapshot.realId = serverCart.id;
                                          // [v39-OMEGA-UUID] Server UUID is the absolute Law
                                          if (serverCart.branchTableUId) {
                                              cartSnapshot.branchTableUId = serverCart.branchTableUId;
                                          }
                                          console.log("[v39-OMEGA-UUID] Synchronized - RowVersion:", cartSnapshot.rowVersion, "RealId:", cartSnapshot.id, "UUID:", cartSnapshot.branchTableUId);
                                      }
                                  }
                              } catch (resErr) { console.error("[v37-OMEGA-RESERVE] Reserve/Pull Failed:", resErr); }

                              const masterTableRes = await getCartsByTableId(cartSnapshot.id || cartSnapshot.tableId);
                              if (masterTableRes && masterTableRes.data && masterTableRes.data.rowVersion) {
                                  cartSnapshot.rowVersion = masterTableRes.data.rowVersion;
                                  console.log("[v29-MASTER-SYNC] RowVersion recovered from BranchTables API:", cartSnapshot.rowVersion);
                                  
                                  if (!cartSnapshot.branchTableUId && masterTableRes.data.branchTableUId) {
                                      cartSnapshot.branchTableUId = masterTableRes.data.branchTableUId;
                                      console.log("[v29-MASTER-SYNC] UUID recovered from BranchTables API:", cartSnapshot.branchTableUId);
                                  }
                              } else {
                                  console.error("[v29-MASTER-SYNC] Master Table API also returned NULL. Keeping local version:", cartSnapshot.rowVersion);
                              }
                          } catch (masterErr) {
                              console.error("[v29-MASTER-SYNC] Master Sync Failed:", masterErr);
                          }
                      }

                      // CRITICAL: UUID Missing in Snapshot? Fix it from local or store or GENERATE [v26 ARMOR-HEAL]
                      if (!cartSnapshot.branchTableUId) {
                          cartSnapshot.branchTableUId = latestCartRes.data.branchTableUId || this.localBranchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null);
                          
                          if (!cartSnapshot.branchTableUId) {
                              cartSnapshot.branchTableUId = uuid.v1();
                              console.warn("[ARMOR v26-HEAL-OrderListPayment] UUID STILL NULL. Generated new one:", cartSnapshot.branchTableUId);
                          }
                      }
                      console.log("[Atomic Sync v26-HEAL] Final Snapshot Data:", { 
                          rowVersion: cartSnapshot.rowVersion, 
                          branchTableUId: cartSnapshot.branchTableUId 
                      });
                  }
              } catch(e) { console.error("[Atomic Sync v26] Failed:", e); }
          }

          if (!cartSnapshot) {
              this.$vs.notify({ color: "danger", title: "Hata", text: "Sepet verisine ulaşılamadı. Lütfen tekrar deneyiniz." });
              this.isLoading = false;
              this.isTransaction = false;
              return;
          }

          console.log("[DEBUG] createCommitModel - Pre-Snapshot Data:", {
            cartSnapshot: JSON.parse(JSON.stringify(cartSnapshot)),
            paymentGroups: JSON.parse(JSON.stringify(this.paymentGroups)),
            synchronizedEntries: JSON.parse(JSON.stringify(synchronizedEntries)),
            orderPayments: JSON.parse(JSON.stringify(this.orderPayments)),
            submissionId: this.submissionId,
            localBranchTableUId: this.localBranchTableUId
          });

          // [v36-DEEP-SYNC] Masa Numarası -> Gerçek Sunucu ID'si Eşleşmesi
          let serverSideTableId = cartSnapshot.tableId; 
          try {
              const allCarts = this.$store.getters["selfservice/getCarts"] || [];
              const serverCart = allCarts.find(c => c && (c.tableId == cartSnapshot.tableId || c.tableId == this.selectedTableId));
              if (serverCart && serverCart.id && serverCart.id > 1000) {
                  serverSideTableId = serverCart.id;
                  console.log(`[v36-DEEP-SYNC] Mapped Table ${cartSnapshot.tableId} to ServerID: ${serverSideTableId}`);
              } else {
                  console.warn(`[v36-DEEP-SYNC] Table ${cartSnapshot.tableId} NOT found in server carts list. Using fallback.`);
              }
          } catch (deepErr) { console.error("[v36-DEEP-SYNC] Lookup Failed:", deepErr); }

          // Mevcut orderModel var mı kontrol et, yoksa yarat
          if (typeof this._orderModelSnapshot === 'undefined' || this._orderModelSnapshot === null) {
              // [v31] FORCE-SAVE: Eğer hala RowVersion yoksa (Hayalet Sepet), sunucuya zorla kaydet
              if (this.isTableMode && !cartSnapshot.rowVersion) {
                  console.warn("[v31-FORCE-SAVE] RowVersion still missing. Forcing server record creation...");
                  try {
                      console.log("[v34-DEBUG] Force Save Payload:", { value: cartSnapshot, tableId: cartSnapshot.id || cartSnapshot.tableId, branchTableUId: cartSnapshot.branchTableUId });
                      const forceSaveRes = await setBranchCart({ 
                          value: cartSnapshot, 
                          tableId: cartSnapshot.id || cartSnapshot.tableId, 
                          branchTableUId: cartSnapshot.branchTableUId 
                      });
                      console.log("[v34-DEBUG] Force Save Response:", forceSaveRes);
                      if (forceSaveRes && forceSaveRes.data) {
                          const sData = forceSaveRes.data;
                          // [v40-DEEP-FORCE] Capture EVERYTHING from the server response
                          cartSnapshot.rowVersion = sData.rowVersion || sData.RowVersion;
                          if (sData.id || sData.Id) {
                              const newId = sData.id || sData.Id;
                              cartSnapshot.id = newId;
                              cartSnapshot.realId = newId;
                              cartSnapshot.tableId = newId; // [v40] Anchor tableId to the record ID
                              console.log("[v40-DEEP-FORCE] ID Anchored to Server Record ID:", cartSnapshot.id);
                          }
                          if (sData.branchTableUId || sData.BranchTableUId) {
                              cartSnapshot.branchTableUId = sData.branchTableUId || sData.BranchTableUId;
                          }
                          console.log("[v40-DEEP-FORCE] Sync Success. RowVersion:", cartSnapshot.rowVersion, "UUID:", cartSnapshot.branchTableUId);
                      }
                  } catch (forceErr) {
                      console.error("[v34-DEBUG] Force Save Failed:", forceErr);
                  }
              }

              // v118.Beta-Final-17.V4 [FROZEN-SNAPSHOT]: Sipariş tamamlanmadan hemen önce sepeti tam kopya ile dondur.
              // Bu sayede "Adisyon Yazdırma" ekranındaki stabiliteyi ödeme fişine de taşıyoruz.
              const frozenCart = JSON.parse(JSON.stringify(this.currentCart || {}));
              if (frozenCart) {
                  // Computed değerleri o anki doğru halleriyle (sum-based) oku ve dondur
                  this.snapshotTotalOriginPrice = parseFloat(this.totalOriginPrice) || 0;
                  this.snapshotTotalDiscountPrice = parseFloat(this.totalDiscountPrice) || 0;
                  this.snapshotTotalPrice = parseFloat(this.totalPrice) || 0;
                  this.snapshotTotalPaidAmount = parseFloat(this.totalPaidAmount) || 0;
                  this.snapshotOrderPayments = frozenCart.orderPayments ? JSON.parse(JSON.stringify(frozenCart.orderPayments)) : [];
                  this.snapshotBillEntries = this.orderBillEntries ? JSON.parse(JSON.stringify(this.orderBillEntries)) : [];
                  this.snapshotTableName = this.tableName;

                  // Yazıcı modeli için ek alanları dondur
                  frozenCart.totalOriginPrice = Math.round(this.snapshotTotalOriginPrice * 100) / 100;
                  frozenCart.totalDiscountPrice = Math.round(this.snapshotTotalDiscountPrice * 100) / 100;
                  frozenCart.totalPrice = Math.round((parseFloat(this.totalPrice) || 0) * 100) / 100;
                  frozenCart.totalPayedPrice = Math.round((parseFloat(this.totalPaidAmount) || 0) * 100) / 100;
                  frozenCart.tableName = this.snapshotTableName;
                  frozenCart.isAdisyon = false;
              }

              // v118.Alpha-Final-25: Sync frontend checkbox to backend printerActive flag
              cartSnapshot.printerActive = this.isPrintOrders;
              if (!cartSnapshot.printerName) cartSnapshot.printerName = this.printerSettings.mainPrinterName || "Mutfak";

              this._orderModelSnapshot = {
                  id: cartSnapshot.id || 0,
                  tableId: cartSnapshot.branchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null),
                  branchTableUId: cartSnapshot.branchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null),
                  rowVersion: cartSnapshot.rowVersion || null,
                  isNavigatedByQuestion: cartSnapshot.isNavigatedByQuestion,
                  customerId: cartSnapshot.customer ? cartSnapshot.customer.id : null,
                  totalPrice: cartSnapshot.totalPrice,
                  userName: this.activePersonel ? `${this.activePersonel.name} ${this.activePersonel.surname}` : null,
                  userId: this.activePersonel ? this.activePersonel.id : null,
                  discounts: [...(this.discounts || [])],
                  cart: JSON.parse(JSON.stringify(cartSnapshot)),
                  paymentInformations: [...this.orderPayments],
                  cartEntries: synchronizedEntries.length > 0 ? synchronizedEntries : cartSnapshot.cartEntries,
                  description: (this.descriptionPromptText || "") + ` [SID:${this.localBranchTableUId}]`,
                  submissionId: this.submissionId || ("sub_" + Date.now()),
                  branchId: this.$store.state.AppActiveUser.branch.id,
                  orderStatus: 1,
                  orderDeliveryType: 1
              };
          }
   
          console.log("[v36-JSON-DEBUG] OrderModel Object:", this._orderModelSnapshot);
          console.log("[v36-JSON-DEBUG] OrderModel RAW JSON:", JSON.stringify(this._orderModelSnapshot));
          
          let result;
          try {
              result = await completePayment(this._orderModelSnapshot);
              console.log("[v34-DEBUG] completePayment Result:", result);
          } catch (err) {
              console.error("[v34-DEBUG-ERROR] 422 Body:", err.response ? err.response.data : "No response data");
              this.$vs.notify({ color: "danger", title: "Hata", text: "Ödeme backend tarafından onaylanmadı." });
              this.isTransaction = false;
              this.isLoading = false;
              return;
          }

          const isSuccess = (result === true) || (result && result.isValid !== false && (result.data ? result.data.isValid !== false : true));

          // CRITICAL Safety: result.data crash handler
          let proceedToCleanup = isSuccess;
          if (!isSuccess && result && typeof result === 'object' && result.data && (result.data.rowVersion || result.data.RowVersion)) {
              proceedToCleanup = true;
              console.log("Ödeme zaten tamamlanmış görünüyor, klozür işlemine devam ediliyor.");
          }

          if (!proceedToCleanup) {
              this.$vs.notify({ color: "danger", title: "Hata", text: "Ödeme backend tarafından onaylanmadı." });
              this.isTransaction = false;
              return;
          }

          console.log("completePayment Başarılı veya Zaten Ödenmiş:", result);

          // RowVersion Senkronizasyonu & Global Sync (v24)
          if (result && typeof result === 'object' && result.data && result.data.rowVersion) {
              try {
                  const refreshedCartsRes = await getCarts();
                  if (refreshedCartsRes && refreshedCartsRes.data) {
                      this.$store.dispatch("selfservice/setToCart", refreshedCartsRes.data);
                  }
              } catch (syncErr) { console.error("Post-Payment Sync fail", syncErr); }
              
              const allCarts = this.$store.getters["selfservice/getCarts"] || [];
              const masterStoreCart = allCarts.find(c => c && c.tableId == cartSnapshot.tableId);
              if (masterStoreCart && masterStoreCart.rowVersion) {
                  cartSnapshot.rowVersion = masterStoreCart.rowVersion;
              } else if (result.data.rowVersion) {
                  cartSnapshot.rowVersion = result.data.rowVersion;
              }
            }
          this.orderBillNo = cartSnapshot.orderNo || (result.data ? result.data.orderNo : 0);
          
          // v118.V9 [SID-RECOVERY-DRIVEN]: DB'deki Description (SID) üzerinden siparişi yakala. (En güvenli yöntem)
          if (this.isPrintOrders) {
             try {
                if (this.$refs.printer) {
                    if (this.localBranchTableUId && this.localBranchId) {
                       console.log("[v118.V9] Triggering SID-based customer receipt print:", this.localBranchTableUId);
                       this.$refs.printer.handleDBSuccessPrint(this.localBranchTableUId, this.localBranchId);
                    } else {
                       const rData = result.data || {};
                       const orderId = result.id || result.Id || rData.id || rData.Id || cartSnapshot.id;
                       console.log("[v118.V9] SID missing, falling back to ID-based customer print:", orderId);
                       this.$refs.printer.fetchAndPrint(orderId, this.printCopyCount, true, this.orderBillNo);
                    }
                }
             } catch(pErr) { console.error("V25 Print Trigger Error:", pErr); }
          }
 
          this.discounts = []; // v118.Beta-Final-9: İndirimleri en sonunda (Yazma bittikten sonra) temizle

          // 6. MÜŞTERİ DURUMU
          // [v25-PASSED] Müşteri Durumu Popup (User request: Disable for now)
          let customerLeft = true; 
          /*
          if (this.isTableMode) {
            if (this.currentCart && this.currentCart.notSeat) {
               customerLeft = true;
            } else {
              try {
                await new Promise((resolve) => {
                  this.$vs.dialog({
                    type: "confirm", color: "warning", title: "Müşteri Durumu", text: "Müşteri masadan kalktı mı?",
                    acceptText: "Evet, Kalktı", cancelText: "Hayır, Hala Oturuyor",
                    accept: () => { customerLeft = true; resolve(); },
                    cancel: () => { customerLeft = false; resolve(); },
                  });
                  setTimeout(() => resolve(), 10000);
                });
              } catch(e) { customerLeft = true; }
            }
          }
          */

          // 7. MASA KAPATMA (Cleanup)
          await this.finalizeClosure(cartSnapshot, customerLeft);

        } catch (err) {
          console.error("[ARMOR v27] createCommitModel Error:", err);
          
          // CRITICAL: Hata durumunda snapshot'ı temizle ki bir sonraki denemede Atomic Sync tekrar çalışsın.
          this._orderModelSnapshot = null;
          this.submissionId = null;

          if (err.message && (err.message.includes("422") || err.message.includes("onaylamadı"))) {
             console.log("[ARMOR v27] 422 Detected. Table will NOT be cleared. User must retry.");
             this.$fire({ title: "Hata (422)!", text: "Sipariş sunucu tarafından reddedildi. Masa verisi korundu. Lütfen tekrar deneyiniz.", type: "error" });
          } else {
             this.$fire({ title: "Hata !", text: "Sipariş kaydedilemedi: " + (err.message || "Bilinmeyen hata"), type: "error" });
          }
          this.isTransaction = false;
        } finally {
          this.isLoading = false;
        }
    },

    finalizeClosure: async function(cartRef, customerLeft) {
      try {
          let targetIds = [];
          if (cartRef.tableId) targetIds.push(cartRef.tableId);
          if (cartRef.id && !targetIds.includes(cartRef.id)) targetIds.push(cartRef.id);
          
          const finalMergedIds = (this.localMergedIds && this.localMergedIds.length > 0) ? this.localMergedIds : (cartRef.mergedIds || []);
          if (finalMergedIds && Array.isArray(finalMergedIds)) {
            finalMergedIds.forEach(id => { if (id && !targetIds.includes(id)) targetIds.push(id); });
          }

          // CRITICAL: Masa adı kaymasını önlemek için döngü öncesi tüm bağlı masaları pasif yapmayı denebiliriz, 
          // ancak döngü içinde yapmak daha kontrollü.
          for (let tid of targetIds) {
            if (!tid) continue;
            let cleanupCart = JSON.parse(JSON.stringify(cartRef));
            cleanupCart.id = tid;
            cleanupCart.tableId = tid;
            
            // CRITICAL [v23]: Kesin Klozür Mantığı
            // Ana masa (cartRef.tableId) için en güncel versiyonu kullan.
            // İkincil masalar (tid !== cartRef.tableId) için versiyon kontrolünü DEVRE DIŞI bırakıyoruz 
            // çünkü bu masalar zaten boşa çıkmalı, versiyon çakışması kapatmaya engel olmamalı.
            const allCarts = this.$store.getters["selfservice/getCarts"] || [];
            const currentStoreCart = allCarts.find(c => c && c.tableId == tid);
            
            if (tid == cartRef.tableId) {
                // Ana masa: Mümkün olan en güncel versiyonu al
                if (currentStoreCart && currentStoreCart.rowVersion) {
                    cleanupCart.rowVersion = currentStoreCart.rowVersion;
                }
            } else {
                // İkincil masalar: Versiyonu sil ki çakışma (409) ihtimali sıfırlansın
                if (cleanupCart.rowVersion) {
                    delete cleanupCart.rowVersion;
                }
            }

            cleanupCart.paymentGroups = [];
            cleanupCart.cartEntries = [];
            cleanupCart.totalPrice = 0;
            cleanupCart.totalPayedPrice = 0;
            cleanupCart.orderPayments = [];
            cleanupCart.entries = [];
            cleanupCart.discounts = [];
            cleanupCart.mergedIds = [];
            cleanupCart.isMerged = false;
            cleanupCart.isMerge = false;

            // CRITICAL: Masa adı kaymasını önlemek için sadece ANA masa aktif kalsın (eğer kalkmadıysa)
            // İkincil masalar her durumda active: false olmalı.
            if (customerLeft || cartRef.notSeat) {
                // UI Tarafında masayı hemen kaldır (Kritik: tid String olmalı)
                const tableIdToClear = String(tid);
                this.$store.dispatch("selfservice/removeCart", tableIdToClear);
                
                cleanupCart.active = false;
                cleanupCart.isFullTable = false;
                // REFRESH: Bir sonraki seans için yeni bir UUID üret (Kullanıcı Talebi)
                cleanupCart.branchTableUId = uuid.v1();
                
                try {
                    // 1. Standart deneme (remove: false - Update instead of delete)
                    await setBranchCart({ value: cleanupCart, tableId: tableIdToClear, branchTableUId: cleanupCart.branchTableUId, remove: false });
                } catch (cleanErr) {
                    // 2. Fallback: unReserveTable (Zorla Boşalt)
                    console.warn(`Fallback (v25): unReserveTable for ${tableIdToClear}`);
                    await unReserveTable(tableIdToClear).catch(e => console.error("Final unreserve fail:", tableIdToClear, e));
                }
            } else {
               // Müşteri kalkmadıysa
               cleanupCart.active = (tid === cartRef.tableId); // Sadece ana masa aktif kalsın
               cleanupCart.isFullTable = true;
               cleanupCart.customer = null;
               this.$store.dispatch("selfservice/updateCartsById", [cleanupCart]);
               await setBranchCart({ value: cleanupCart, tableId: tid, branchTableUId: cleanupCart.branchTableUId, remove: false }).catch(e => console.error("setBranchCart update fail:", tid, e));
            }
          }
          
          // Vuesax popup fallback cleanup
          let calcPopup = document.querySelector('.vs-popup-primary'); 
          if (calcPopup && calcPopup.parentElement && calcPopup.parentElement.parentElement) {
             calcPopup.parentElement.parentElement.classList.remove('active');
          }
      } catch (closureErr) {
        console.error("Closure/Cleanup error:", closureErr);
      } finally {
        this.isActive = false;
        this.isTransaction = false;
        this.resetSnapshot();
        this.$emit("switchToTableMap");
      }
    },

    resetSnapshot() {
      if (typeof this._orderModelSnapshot !== 'undefined') {
          this._orderModelSnapshot = null;
      }
    },

    seperatePayment() {
      if (this.selectedPaymentGroup.length > 0) {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.toggleCalc = true;
      } else {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.paymentGroups);
        this.toggleCalc = true;
      }
    },

    checkPosDevice: async function () {
      var userInfo = JSON.parse(localStorage.getItem("userInfo"));
      var branchId = userInfo.branch.id;
      var axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
      this.posType = axiosResponse.data.posType;
      this.posData = axiosResponse.data;
    },
    checkPosConnection: async function () {
      if (!this.isPosEnabled) {
        this.isPosConnectionError = false;
        return;
      }
      let bridgeUrl = process.env.VUE_APP_POS_API;
      if (!bridgeUrl) {
        this.isPosConnectionError = true;
        return;
      }
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 1500);

      try {
        const response = await fetch(bridgeUrl, {
          method: "GET",
          signal: controller.signal,
          headers: {
            "Accept": "application/json"
          }
        });
        clearTimeout(timeoutId);
        this.isPosConnectionError = false;
      } catch (err) {
        clearTimeout(timeoutId);
        this.isPosConnectionError = true;
        console.warn("POS Bridge connection check failed:", err);
      }
    },
    startPosConnectionTimer() {
      this.stopPosConnectionTimer();
      this.checkPosConnection();
      this.posConnectionInterval = setInterval(() => {
        this.checkPosConnection();
      }, 5000);
    },
    stopPosConnectionTimer() {
      if (this.posConnectionInterval) {
        clearInterval(this.posConnectionInterval);
        this.posConnectionInterval = null;
      }
    },

    setIsPieced: function () {
      this.isPieced = true;
    },

    doPayWithoutPos: async function (payedPrice, isDiscount) {
      if (this.isTransaction && !isDiscount) {
         console.warn("doPayWithoutPos blocked by isTransaction flag!");
         return;
      }
      // Seçilen gruplarda çalışan süreli ürün varsa ödeme yapılamaz
      if (this.hasRunningTimeProducts) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Seçilen ürünlerde çalışan süreli ürünler var. Önce onları durdurunuz!",
        });
        return;
      }
      this.isTransaction = true;
      
      try {

        if (this.selectedPaymentMethod.id == process.env.VUE_APP_WALLET_PAYMENT_ID) {
          this.openQrReader(payedPrice, isDiscount);
          this.isTransaction = false;
          return;
        }

        if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && !this.selectedCari) {
          this.$refs.cariSelect.openPopup();
          this.isTransaction = false;
          return;
        }

        // Deep clone paymentGroups so modifications don't mutate Vuex
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
        } else {
          // If already selected, ensure it's cloned independently
          this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
        }

        var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
        var distributedAmount = 0;
        var payedPriceFloat = parseFloat(payedPrice);

        this.selectedPaymentGroup.forEach((group, index) => {
          var remaining = group.totalPrice - group.payedPrice;
          var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
          
          var chunk = 0;
          if (index === this.selectedPaymentGroup.length - 1) {
            chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
          } else {
            chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
          }
          
          group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
          if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
          distributedAmount += chunk;

          if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
            group.status = "Ödendi";
          }
        });

        // Merge selected modifications back into the global paymentGroups list
        this.selectedPaymentGroup.forEach((modifiedGroup) => {
           let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
           if (idx !== -1) {
             // Mutating our local list (which is cloned inside initValues, thus safe from Vuex)
             this.$set(this.paymentGroups, idx, modifiedGroup);
           }
        });

        // Hata buradaydı: selectedPaymentGroup referansını tüm sepetle eşitleyip boşaltıyorduk.
        // Array'e etki ettik, şimdi selectedPaymentGroup'tan temizleyebiliriz ama 
        // paymentGroups ui'da tazelemeli:
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.selectedPaymentGroup = [];
        this.reCalculatePaymentGroup();

        var selectedPgs = [];

        var orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedPrice,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null,
          discountDescription: isDiscount ? this.paymentDiscount.discountDescription : null,
          selectedPaymentGroup: selectedPgs,
        };

        if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && this.selectedCari) {
          orderPayment.cariId = this.selectedCari.id;
          orderPayment.cariName = this.selectedCari.name;
        }

        this.orderPayments.push(orderPayment);
        this.toggleCalc = false;
  
        // SAFE CLONE & RECOVERY: Reaktivite veya polling sırasında sepetin kaybolması durumuna karşı UUID koruması
        let clonedCart = Object.assign({}, this.currentCart || {});
        if (!clonedCart.id && this.localBranchTableUId) {
            console.warn("doPayWithoutPos: currentCart is NULL, attempting to recover by UUID (anchor):", this.localBranchTableUId);
            const allCarts = this.$store.getters["selfservice/getCarts"];
            const recovered = allCarts.find(c => c && c.branchTableUId === this.localBranchTableUId);
            if (recovered) {
                clonedCart = Object.assign({}, recovered);
                clonedCart.active = true; // Re-activate it locally
                console.log("doPayWithoutPos: Cart recovered successfully by UUID.");
            } else if (this.paymentGroups.length > 0) {
                console.error("doPayWithoutPos: CRITICAL - Cart could not be recovered even by tableId!");
            }
        }

        clonedCart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
        clonedCart.totalPayedPrice = Math.round(((clonedCart.totalPayedPrice || 0) + payedPrice) * 100) / 100;
        clonedCart.remainingAmount = Math.round(((clonedCart.totalPrice || 0) - clonedCart.totalPayedPrice) * 100) / 100;
        clonedCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
        clonedCart.discounts = [...this.discounts];
  
        // CRITICAL: Birleşmiş masa bilgisini (mergedIds) her zaman koru
        if (this.localMergedIds && this.localMergedIds.length > 0) {
            clonedCart.mergedIds = [...this.localMergedIds];
            clonedCart.isMerged = true;
        } else if (this.currentCart && this.currentCart.mergedIds) {
            clonedCart.mergedIds = [...this.currentCart.mergedIds];
            clonedCart.isMerged = !!(clonedCart.mergedIds.length > 0);
        }

        // POST the cart. Eger patlarsa catch'e düseriz.
        // SAFE SAVE: clonedCart'ın derin kopyasını alarak reaktif veri bozulmalarını önleyelim.
        // Tüm alanları (cartEntries, mergedIds, vb.) içeren tam nesneyi gönderiyoruz.
        let cartToSave = JSON.parse(JSON.stringify(clonedCart));
        cartToSave.active = true;
        cartToSave.isFullTable = true;
        // CRITICAL [v22]: Harita (TableMap.html) "v-if='!button.isMerged'" kontrolü yaptığı için, 
        // ana masanın görünür kalması için isMerged FALSE olmalıdır. 
        cartToSave.isMerged = false; 
        
        const branchId = this.$store.state.AppActiveUser.branch.id;
        cartToSave.branchId = branchId;
        
        const saveRes = await setBranchCart({ 
          value: cartToSave, 
          tableId: cartToSave.tableId,
          branchTableUId: cartToSave.branchTableUId // UUID bazlı birincil anahtar
        });

        // CRITICAL: Sunucudan dönen yeni rowVersion'u yakala ve objeye işle
        if (saveRes && saveRes.data && saveRes.data.rowVersion) {
            let updatedMainCart = JSON.parse(JSON.stringify(clonedCart));
            updatedMainCart.rowVersion = saveRes.data.rowVersion;
            this.$store.dispatch("selfservice/updateCartsById", [updatedMainCart]);
            console.log("DoPay: Main Table version synced.");
        }

        // CRITICAL [v21]: Birleşmiş masalar için Geliştirilmiş Ping Lojiği.
        if (cartToSave.mergedIds && cartToSave.mergedIds.length > 0) {
            const allCarts = this.$store.getters["selfservice/getCarts"];
            for (const mId of cartToSave.mergedIds) {
                try {
                    let existingMCart = allCarts.find(c => c && c.tableId === mId);
                    let mValue = existingMCart ? JSON.parse(JSON.stringify(existingMCart)) : { tableId: mId };
                    
                    mValue.branchId = branchId;
                    mValue.isFullTable = true;
                    mValue.active = true;
                    mValue.isMerged = true;
                    mValue.mergedIds = [...cartToSave.mergedIds];

                    const mSaveRes = await setBranchCart({ value: mValue, tableId: mId, branchTableUId: (this.currentCart ? this.currentCart.branchTableUId : null) });
                    
                    // CRITICAL: İkincil masanın yeni versiyonunu yakala ve store'u güncelle
                    if (mSaveRes && mSaveRes.data && mSaveRes.data.rowVersion) {
                        mValue.rowVersion = mSaveRes.data.rowVersion;
                        // Mutasyon yerine yeni bir kopya ile store'u güncelle
                        this.$store.dispatch("selfservice/updateCartsById", [JSON.parse(JSON.stringify(mValue))]);
                        console.log("Secondary table version synced:", mId, mSaveRes.data.rowVersion);
                    }
                } catch (mErr) {
                    console.error("Secondary table safe ping error (v21):", mErr);
                }
            }
        }

        // CRITICAL: Backend'den dönen güncel RowVersion'u yakala ve objeye işle
        if (saveRes && saveRes.data && saveRes.data.rowVersion) {
            clonedCart.rowVersion = saveRes.data.rowVersion;
        }
        
        // CRITICAL: Yerel state'i Vuex store ile kesin olarak senkronize et ki 
        // bir sonraki ödeme veya commit bayat veri görmesin.
        this.$store.dispatch("selfservice/updateCartsById", [clonedCart]);
        
      } catch (err) {
        console.error("doPayWithoutPos error:", err);
      } finally {
        // Vue 2 reaktivitesini zorla: dizi referansını yenile
        this.paymentGroups = [...this.paymentGroups];
        
        // Asenkron gecikmeyi bekle ve ardından durumu kontrol et.
        this.$nextTick(() => {
          // İndirim veya normal ödeme sonrası işlemi aç
          this.isTransaction = false;
          
          if (!isDiscount) {
            this.selectedCari = null;
          }
          
          const remaining = this.calculateSelectedRemainingPrice(this.paymentGroups);
          const rounded = Math.round(remaining * 100) / 100;
          
          console.log("doPayWithoutPos finally - remaining (rounded):", rounded, "isActive:", this.isActive);
          
          if (rounded <= 0 && this.isActive) {
            console.log("doPayWithoutPos finally - Committing order!");
            this.isCommitable = true;
            this.createCommitModel();
          }
        });
      }
    },

    doPay: async function (payedPrice, isDiscount) {
      if (this.isTransaction && !isDiscount) return;
      this.isTransaction = true;

      if (this.isPosConnectionError && !isDiscount && this.selectedPaymentMethod && 
          (this.selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID)) {
        this.$vs.notify({
          color: "danger",
          title: "Bağlantı Hatası",
          text: "POS Bridge bağlantısı olmadığı için ödeme yapılamaz!",
        });
        this.isTransaction = false;
        return;
      }

      if (this.hasRunningTimeProducts) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Seçilen ürünlerde çalışan süreli ürünler var. Önce onları durdurunuz!",
        });
        this.$nextTick(() => {
          this.isTransaction = false;
        });
        return;
      }

      if (this.posType == parseInt(process.env.VUE_APP_POS_GMP)) {
        this.doPayGmp(payedPrice, isDiscount);
        return;
      }

      if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && !this.selectedCari && !isDiscount) {
        this.$refs.cariSelect.openPopup();
        this.$nextTick(() => {
          this.isTransaction = false;
        });
        return;
      }

      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
      } else {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
      }

      var posSaleItems = [];
      var currentSelectedGroups = this.selectedPaymentGroup;
      
      // Toplam seçili tutarı (kalan borçlar toplamı) hesapla
      const totalRemainingOfSelected = currentSelectedGroups.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
      let distributedAcrossGroups = 0;
      const targetPayedPrice = parseFloat(payedPrice);

      currentSelectedGroups.forEach((selectProduct, gIdx) => {
        if (selectProduct.payedPrice != selectProduct.totalPrice) {
          // Bu ürüne düşen ödeme payını hesapla (Oransal Dağıtım)
          let ratio = totalRemainingOfSelected > 0 ? ((selectProduct.totalPrice - selectProduct.payedPrice) / totalRemainingOfSelected) : 0;
          let groupTargetPrice = (gIdx === currentSelectedGroups.length - 1)
            ? (targetPayedPrice - distributedAcrossGroups)
            : (targetPayedPrice * ratio);
          
          groupTargetPrice = Math.round(groupTargetPrice * 100) / 100;
          distributedAcrossGroups += groupTargetPrice;

          if (groupTargetPrice > 0) {
            if (selectProduct.entries.length == 1) {
              posSaleItems.push({
                id: selectProduct.entries[0].productId || selectProduct.entries[0].id || 0,
                name: selectProduct.entries[0].productName,
                quantity: selectProduct.entries[0].quantity,
                kdv: selectProduct.entries[0].kdv,
                price: groupTargetPrice, // Artik kalan borç değil, dağıtılan payı gönderiyoruz
              });
            } else {
              let groupDistributed = 0;
              selectProduct.entries.forEach((entry, eIdx) => {
                let eRatio = selectProduct.totalPrice > 0 ? (entry.price / selectProduct.totalPrice) : 0;
                let eChunk = (eIdx === selectProduct.entries.length - 1)
                  ? Math.round((groupTargetPrice - groupDistributed) * 100) / 100
                  : Math.round((groupTargetPrice * eRatio) * 100) / 100;

                posSaleItems.push({
                  name: entry.productName,
                  quantity: entry.quantity,
                  kdv: entry.kdv,
                  price: eChunk,
                });
                groupDistributed += eChunk;
              });
            }
          }
        }
      });

      let data = null;
      let fetchFailed = false;

      try {
        this.isLoading = true;
        const response = await fetch(process.env.VUE_APP_POS_API + "complete-sale", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            PaymentType: this.selectedPaymentMethod.id == process.env.VUE_APP_CREDIT_PAYMENT_ID ? 4 : 1,
            SaleItems: posSaleItems,
          }),
        });
        
        if (!response.ok) {
           throw new Error(`HTTP Hata: ${response.status}`);
        }

        data = await response.json();
      } catch (err) {
        fetchFailed = true;
        this.isLoading = false;
        console.error("POS Hatası (Catch):", err);
        
        if (this.selectedPaymentMethod && 
            (this.selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID)) {
          this.$vs.notify({
            color: "danger",
            title: "POS Hatası",
            text: "POS cihazından yanıt alınamadı. Ödeme işlemi gerçekleştirilemedi!",
          });
          this.isTransaction = false;
          return;
        }
        
        setTimeout(async () => {
          // Sessiz Başarı (Silent Success) Mantığı (Kullanıcı talebi üzerine geri eklendi)
          console.warn("Sunucu 500 hatası verdi ancak işlem başarılı sayılıp tamamlanıyor (Sessiz Başarı).");
            const payedPriceFloat = parseFloat(payedPrice);
            
            this.isPaymentStarted = true;
            const totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
            let distributedAmount = 0;

            this.selectedPaymentGroup.forEach((group, index) => {
                const remaining = group.totalPrice - group.payedPrice;
                const pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
                const chunk = (index === this.selectedPaymentGroup.length - 1)
                    ? Math.round((payedPriceFloat - distributedAmount) * 100) / 100
                    : Math.round((payedPriceFloat * pRatio) * 100) / 100;

                group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
                distributedAmount += chunk;
            });

            // Yerel değişiklikleri ana listeye geri yansıt (Merge back)
            this.selectedPaymentGroup.forEach((modifiedGroup) => {
               let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
               if (idx !== -1) {
                 this.$set(this.paymentGroups, idx, modifiedGroup);
               }
            });

            this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
            this.selectedPaymentGroup = [];
            this.reCalculatePaymentGroup();

            this.orderPayments.push({
                id: uuid.v1(),
                paymentMethod: _.cloneDeep(this.selectedPaymentMethod),
                price: payedPrice
            });

            let clonedCart = Object.assign({}, this.$store.getters["selfservice/getCurrentCart"]);
            clonedCart.totalPayedPrice = Math.round((clonedCart.totalPayedPrice + payedPriceFloat) * 100) / 100;
            clonedCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
            
            this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
            const saveRes = await setBranchCart({ value: clonedCart, tableId: clonedCart.tableId, branchTableUId: clonedCart.branchTableUId });
            
            // CRITICAL [v25]: RowVersion sync after silent success
            if (saveRes && saveRes.data && saveRes.data.rowVersion) {
                clonedCart.rowVersion = saveRes.data.rowVersion;
                if (this.currentCart) this.currentCart.rowVersion = saveRes.data.rowVersion;
                this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
                console.log("[RowVersion Sync] Updated after silent success:", saveRes.data.rowVersion);
            }

            this.isTransaction = false;
            const remaining = this.calculateSelectedRemainingPrice(this.paymentGroups);
            if (Math.round(remaining * 100) / 100 <= 0 && this.isActive) {
                this.createCommitModel();
            }
        }, 500);
      }

      if (!fetchFailed && data) {
        this.isLoading = false;

        // 1. Kesin Başarı Doğrulaması (MainStatus 6 Olanlar)
        const successStatuses = [3, 4, 5, 6, 8, 9, 10, 18, 19, 20, 21, 22, 24];
        let isStrictSuccess = false;
        let resultData = data.data || data;
        
        if (resultData && successStatuses.includes(resultData.statusId)) {
            isStrictSuccess = true;
        } else if (resultData && resultData.statusId === 23) {
            // İşlem askıda (UnCompleted), CheckPendingSale ile sorgula
            this.$vs.notify({ color: "warning", title: "İşlem Askıda", text: "Ödeme durumu kontrol ediliyor. Lütfen bekleyiniz...", time: 5000 });
            let retryCount = 0;
            let isPendingResolved = false;

            while (retryCount < 10 && !isPendingResolved) {
                await new Promise(r => setTimeout(r, 3000)); // 3 saniye bekle
                try {
                    const checkRes = await fetch(process.env.VUE_APP_POS_API + "CheckPendingSale", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            Sale: {
                                SaleNumber: resultData.saleNumber || resultData.orderNo || (this.orderBillNo ? this.orderBillNo.toString() : null),
                                OrderNo: resultData.orderNo || (this.orderBillNo ? this.orderBillNo.toString() : null)
                            }
                        })
                    });
                    
                    if (checkRes.ok) {
                        const checkData = await checkRes.json();
                        const checkResultData = checkData.data || checkData;
                        
                        if (checkResultData && (successStatuses.includes(checkResultData.statusId) || checkResultData.RemainingPaymentAmount === 0 || checkResultData.remainingPaymentAmount === 0)) {
                            isStrictSuccess = true;
                            isPendingResolved = true;
                            resultData = checkResultData; // Son veriyi güncelle

                            // Ödeme alındı, siparişi tamamla (FinalizeSale)
                            try {
                                await fetch(process.env.VUE_APP_POS_API + "FinalizeSale", {
                                    method: "POST",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        Sale: {
                                            RefererApp: "Pickpos",
                                            RefererAppVersion: "1.0.0",
                                            SaleNumber: checkResultData.saleNumber || checkResultData.SaleNumber || resultData.saleNumber || resultData.orderNo || (this.orderBillNo ? this.orderBillNo.toString() : null),
                                            OrderNo: checkResultData.orderNo || checkResultData.OrderNo || resultData.orderNo || (this.orderBillNo ? this.orderBillNo.toString() : null)
                                        }
                                    })
                                });
                            } catch (finalizeErr) {
                                console.error("FinalizeSale Hatası:", finalizeErr);
                            }
                        } else if (checkResultData && checkResultData.statusId !== 23) {
                            // Askıdan çıkmış ama başarısız olmuş (İptal vb.)
                            isPendingResolved = true;
                        }
                    }
                } catch (e) {
                    console.error("CheckPendingSale Hatası:", e);
                }
                retryCount++;
            }
            
            if (!isStrictSuccess) {
                // Başarı sağlanmadıysa işlemi askıdan düşür (AbandonSuspendedSale)
                try {
                    await fetch(process.env.VUE_APP_POS_API + "AbandonSuspendedSale", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            Sale: {
                                RefererApp: "Pickpos",
                                RefererAppVersion: "1.0.0",
                                SaleNumber: resultData.saleNumber || resultData.orderNo || (this.orderBillNo ? this.orderBillNo.toString() : null),
                                OrderNo: resultData.orderNo || (this.orderBillNo ? this.orderBillNo.toString() : null)
                            }
                        })
                    });
                } catch (abandonErr) {
                    console.error("AbandonSuspendedSale Hatası:", abandonErr);
                }

                if (!isPendingResolved) {
                    this.$vs.notify({ color: "danger", title: "Zaman Aşımı", text: "Askıdaki işlemin sonucu alınamadı ve iptal edildi." });
                } else {
                    this.$vs.notify({ color: "danger", title: "Ödeme Alınamadı", text: "Ödeme işlemi başarısız oldu ve askıdaki kayıt iptal edildi." });
                }
            }
        }

        if (isStrictSuccess) {
          this.isPaymentStarted = true;
          let resultData = data.data || data;
          
          let posStatusId = this.getPaymentMethodIdFromPosResponse(resultData, this.selectedPaymentMethod.id);

          // Dağıtım Mantığı
          const totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
          let distributedAmount = 0;
          const payedPriceFloat = parseFloat(payedPrice);

          this.selectedPaymentGroup.forEach((group, index) => {
            const remaining = group.totalPrice - group.payedPrice;
            const pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
            const chunk = (index === this.selectedPaymentGroup.length - 1)
              ? Math.round((payedPriceFloat - distributedAmount) * 100) / 100
              : Math.round((payedPriceFloat * pRatio) * 100) / 100;

            group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
            if (group.payedPrice > group.totalPrice) {
              group.payedPrice = group.totalPrice;
            }
            distributedAmount += chunk;
            if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
              group.status = "Ödendi";
            }
          });

          // Yerel değişiklikleri ana listeye geri yansıt (Merge back)
          this.selectedPaymentGroup.forEach((modifiedGroup) => {
             let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
             if (idx !== -1) {
               this.$set(this.paymentGroups, idx, modifiedGroup);
             }
          });

          this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
          this.selectedPaymentGroup = [];
          this.reCalculatePaymentGroup();

          const orderPayment = {
            id: uuid.v1(),
            paymentMethod: _.cloneDeep(this.selectedPaymentMethod),
            price: payedPrice,
            value: isDiscount ? this.paymentDiscount.value : null,
            unit: isDiscount ? this.paymentDiscount.unit : null,
            description: isDiscount ? this.paymentDiscount.description : null,
          };
          
          orderPayment.paymentMethod.id = posStatusId;
          
          if (resultData && resultData.financialDocuments && resultData.financialDocuments.length > 0) {
            orderPayment.financialDocument = resultData.financialDocuments[0];
            orderPayment.financialDocument.saleUid = resultData.saleUid;
            orderPayment.financialDocument.orderNo = resultData.orderNo;
          }

          this.orderPayments.push(orderPayment);

          // Sepet Güncelleme
          let clonedCart = Object.assign({}, this.$store.getters["selfservice/getCurrentCart"]);
          clonedCart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
          clonedCart.totalPayedPrice = Math.round((clonedCart.totalPayedPrice + payedPriceFloat) * 100) / 100;
          clonedCart.remainingAmount = Math.round((clonedCart.totalPrice - clonedCart.totalPayedPrice) * 100) / 100;
          clonedCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
          clonedCart.discounts = [...this.discounts];

          // CRITICAL: Birleşmiş masa bilgisini (mergedIds) her zaman koru
          if (this.localMergedIds && this.localMergedIds.length > 0) {
              clonedCart.mergedIds = [...this.localMergedIds];
              clonedCart.isMerged = true;
          } else if (this.$store.getters["selfservice/getCurrentCart"].mergedIds) {
              clonedCart.mergedIds = [...this.$store.getters["selfservice/getCurrentCart"].mergedIds];
              clonedCart.isMerged = !!(clonedCart.mergedIds.length > 0);
          }

          clonedCart.active = true;
          clonedCart.isFullTable = true;

          if (this.isTableMode && clonedCart.id) {
            try {
              const res = await getOrderEntries(clonedCart.id);
              if (res && res.data && res.data.rowVersion) {
                clonedCart.rowVersion = res.data.rowVersion;
              }
            } catch (e) {
              console.error("doPay refresh rowVersion error:", e);
            }
          }

          // SAFE SAVE: clonedCart zaten Object.assign ile alınmış, ama garantici olalım.
          clonedCart.active = true;
          clonedCart.isFullTable = true;
          // CRITICAL [v22]: Haritada görünür kalması için isMerged FALSE olmalı
          clonedCart.isMerged = false;

          this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
          const branchId = this.$store.state.AppActiveUser.branch.id;
          clonedCart.branchId = branchId;

          const saveRes = await setBranchCart({
            value: clonedCart,
            tableId: clonedCart.tableId,
            branchTableUId: clonedCart.branchTableUId
          });

          // CRITICAL [v21]: Birleşmiş masalar için Geliştirilmiş Ping Lojiği
          if (clonedCart.mergedIds && clonedCart.mergedIds.length > 0) {
              const allCarts = this.$store.getters["selfservice/getCarts"];
              for (const mId of clonedCart.mergedIds) {
                  try {
                      let existingMCart = allCarts.find(c => c && c.tableId === mId);
                      let mValue = existingMCart ? JSON.parse(JSON.stringify(existingMCart)) : { tableId: mId };

                      mValue.branchId = branchId;
                      mValue.isFullTable = true;
                      mValue.active = true;
                      mValue.isMerged = true;
                      mValue.mergedIds = [...clonedCart.mergedIds];

                      await setBranchCart({ value: mValue, tableId: mId, branchTableUId: clonedCart.branchTableUId });
                  } catch (mErr) {
                      console.error("Secondary table safe ping error (doPay v21):", mErr);
                  }
              }
          }

          if (saveRes && saveRes.data && saveRes.data.rowVersion) {
              clonedCart.rowVersion = saveRes.data.rowVersion;
              this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
          }

          this.paymentGroups = [...this.paymentGroups];
          this.$nextTick(() => {
            this.isTransaction = false;
            this.selectedCari = null;
            const remaining = this.calculateSelectedRemainingPrice(this.paymentGroups);
            if (Math.round(remaining * 100) / 100 <= 0 && this.isActive) {
              this.isCommitable = true;
              this.createCommitModel();
            }
          });
        } else {
          this.$fire({
            title: "İptal",
            text: data.message || "Ödeme POS cihazından iptal edildi veya başarısız oldu",
            type: "error"
          });
          this.$vs.notify({
            color: "danger",
            title: data.message || "İptal Edildi",
            text: ""
          });
          setTimeout(() => {
            this.isTransaction = false;
          }, 200);
        }
      }
    },

    reCalculatePaymentGroup() {
      if (this.paymentGroups && Array.isArray(this.paymentGroups)) {
        this.paymentGroups.forEach((pgroup) => {
          let totalPrice = 0;
          if (pgroup.entries && Array.isArray(pgroup.entries)) {
            pgroup.entries.forEach((entry) => {
              totalPrice += Math.round((entry.price || 0) * 100) / 100;
            });
          }
          pgroup.totalPrice = Math.round(totalPrice * 100) / 100;
        });
      }
    },

    doPayGmp: async function (payedPrice, isDiscount) {
      try {
        this.isTransaction = true; // GMP ödemesi sırasında popup kapanmasın

        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }

        var posSaleItems = [];
        var currentSelectedGroups = this.selectedPaymentGroup;
        
        // Toplam seçili tutarı (kalan borçlar toplamı) hesapla
        const totalRemainingOfSelected = currentSelectedGroups.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
        let distributedAcrossGroups = 0;
        const targetPayedPrice = parseFloat(payedPrice);

        currentSelectedGroups.forEach((selectProduct, gIdx) => {
          if (selectProduct.payedPrice != selectProduct.totalPrice) {
            // Bu ürüne düşen ödeme payını hesapla (Oransal Dağıtım)
            let ratio = totalRemainingOfSelected > 0 ? ((selectProduct.totalPrice - selectProduct.payedPrice) / totalRemainingOfSelected) : 0;
            let groupTargetPrice = (gIdx === currentSelectedGroups.length - 1)
              ? (targetPayedPrice - distributedAcrossGroups)
              : (targetPayedPrice * ratio);
            
            groupTargetPrice = Math.round(groupTargetPrice * 100) / 100;
            distributedAcrossGroups += groupTargetPrice;

            if (groupTargetPrice > 0) {
              if (selectProduct.entries.length == 1) {
                posSaleItems.push({
                  id: selectProduct.entries[0].productId || selectProduct.entries[0].id || 0,
                  name: selectProduct.entries[0].productName,
                  quantity: selectProduct.entries[0].quantity,
                  kdv: selectProduct.entries[0].kdv,
                  price: Math.round(groupTargetPrice * 1000) / 1000,
                });
              } else {
                let groupDistributed = 0;
                selectProduct.entries.forEach((entry, eIdx) => {
                  let eRatio = selectProduct.totalPrice > 0 ? (entry.price / selectProduct.totalPrice) : 0;
                  let eChunk = (eIdx === selectProduct.entries.length - 1)
                    ? Math.round((groupTargetPrice - groupDistributed) * 100) / 100
                    : Math.round((groupTargetPrice * eRatio) * 100) / 100;
                  
                  posSaleItems.push({
                    id: entry.productId || entry.id || 0,
                    name: entry.productName,
                    quantity: entry.quantity,
                    kdv: entry.kdv,
                    price: Math.round(eChunk * 1000) / 1000,
                  });
                  groupDistributed += eChunk;
                });
              }
            }
          }
        });

        if (isDiscount) {
          // Oransal Dağıtım Mantığı (Merge yerini alıyor)
          var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
          var distributedAmount = 0;
          var payedPriceFloat = parseFloat(payedPrice);

          this.selectedPaymentGroup.forEach((group, index) => {
            var remaining = group.totalPrice - group.payedPrice;
            var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
            
            var chunk = 0;
            if (index === this.selectedPaymentGroup.length - 1) {
              chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
            } else {
              chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
            }
            
            group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
            if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
            distributedAmount += chunk;

            if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
              group.status = "Ödendi";
            }
          });

          this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
          this.selectedPaymentGroup = [];
          this.reCalculatePaymentGroup();

          var orderPayment = {
            id: uuid.v1(),
            paymentMethod: this.selectedPaymentMethod,
            price: payedPrice,
            value: isDiscount ? this.paymentDiscount.value : null,
            unit: isDiscount ? this.paymentDiscount.unit : null,
            description: isDiscount ? this.paymentDiscount.description : null,
          };

          this.orderPayments.push(orderPayment);
          this.toggleCalc = false;

          var currCart = this.currentCart;
          if (currCart) {
            currCart.paymentGroups = this.paymentGroups;
            currCart.totalPayedPrice = Math.round((currCart.totalPayedPrice + payedPrice) * 100) / 100;
            currCart.remainingAmount = Math.round((currCart.totalPrice - currCart.totalPayedPrice) * 100) / 100;
            currCart.orderPayments = this.orderPayments;
            currCart.discounts = this.discounts;
            
            if (this.isTableMode && currCart.id) {
              try {
                let res = await getOrderEntries(currCart.id);
                if (res && res.data && res.data.rowVersion) {
                  currCart.rowVersion = res.data.rowVersion;
                }
              } catch(e) { console.error("Could not fetch fresh rowVersion", e); }
            }
            await setBranchCart({ value: currCart, tableId: currCart.tableId, branchTableUId: currCart.branchTableUId });
            this.isTransaction = false;
          }

        } else {
          this.isLoading = true;
          const response = await fetch(process.env.VUE_APP_POS_API + "create", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              PaymentType: this.selectedPaymentMethod.id == process.env.VUE_APP_CREDIT_PAYMENT_ID ? 4 : 1,
              SaleItems: posSaleItems,
            }),
          });
          
          if (!response.ok) {
              throw new Error("GMP Bridge Error (500)");
          }

          const data = await response.json();
          this.isLoading = false;
          
          let isStrictSuccess = false;
          let resultData = data.data || data;
          if (resultData && resultData.statusId == 4) {
              isStrictSuccess = true;
          }

          if (isStrictSuccess) {
            var totalRem = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
            var distAmount = 0;
            var pPriceFloat = parseFloat(payedPrice);

            this.selectedPaymentGroup.forEach((group, index) => {
              var remaining = group.totalPrice - group.payedPrice;
              var pRatio = totalRem > 0 ? (remaining / totalRem) : 0;
              
              var chunk = 0;
              if (index === this.selectedPaymentGroup.length - 1) {
                chunk = Math.round((pPriceFloat - distAmount) * 100) / 100;
              } else {
                chunk = Math.round((pPriceFloat * pRatio) * 100) / 100;
              }
              
              group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
              if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
              distAmount += chunk;

              if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
                group.status = "Ödendi";
              }
            });

            // Yerel değişiklikleri ana listeye geri yansıt (Merge back)
            this.selectedPaymentGroup.forEach((modifiedGroup) => {
               let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
               if (idx !== -1) {
                 this.$set(this.paymentGroups, idx, modifiedGroup);
               }
            });

            this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
            this.selectedPaymentGroup = [];
            this.reCalculatePaymentGroup();

            var oPayment = {
              id: uuid.v1(),
              paymentMethod: this.selectedPaymentMethod,
              price: payedPrice,
              value: isDiscount ? this.paymentDiscount.value : null,
              unit: isDiscount ? this.paymentDiscount.unit : null,
              description: isDiscount ? this.paymentDiscount.description : null,
            };

            this.orderPayments.push(oPayment);
            this.toggleCalc = false;

            var oCart = this.currentCart;
            if (oCart) {
              oCart.paymentGroups = this.paymentGroups;
              oCart.totalPayedPrice = Math.round((oCart.totalPayedPrice + payedPrice) * 100) / 100;
              oCart.remainingAmount = Math.round((oCart.totalPrice - oCart.totalPayedPrice) * 100) / 100;
              oCart.orderPayments = this.orderPayments;
              oCart.discounts = this.discounts;

              if (this.isTableMode && oCart.id) {
                try {
                  let res = await getOrderEntries(oCart.id);
                  if (res && res.data && res.data.rowVersion) {
                    oCart.rowVersion = res.data.rowVersion;
                  }
                } catch(e) { console.error("Could not fetch fresh rowVersion", e); }
              }

              const saveRes = await setBranchCart({ value: oCart, tableId: oCart.tableId, branchTableUId: oCart.branchTableUId });
              
              // CRITICAL [v25]: RowVersion sync after GMP bridge save
              if (saveRes && saveRes.data && saveRes.data.rowVersion) {
                  oCart.rowVersion = saveRes.data.rowVersion;
                  if (this.currentCart) this.currentCart.rowVersion = saveRes.data.rowVersion;
                  this.$store.dispatch('selfservice/updateCartsById', [oCart]);
              console.log("[RowVersion Sync] Updated after GMP bridge save:", saveRes.data.rowVersion);
          }
        }

        this.$nextTick(() => {
          this.isTransaction = false;
          this.selectedCari = null;
          this.paymentGroups = [...this.paymentGroups];
          
          const remaining = this.calculateSelectedRemainingPrice(this.paymentGroups);
          if (Math.round(remaining * 100) / 100 <= 0 && this.isActive) {
            this.isCommitable = true;
            this.createCommitModel();
          }
        });

          } else {
            this.$fire({
              title: data.message,
              text: "",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: data.message,
              text: "",
            });
            this.isTransaction = false;
          }
        }
      } catch (err) {
        this.isLoading = false;
        console.error("doPayGmp error (Catch):", err);
        
        if (this.selectedPaymentMethod && 
            (this.selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID)) {
          this.$vs.notify({
            color: "danger",
            title: "POS Hatası",
            text: "GMP POS cihazından yanıt alınamadı. Ödeme işlemi gerçekleştirilemedi!",
          });
          this.isTransaction = false;
          return;
        }
        
        setTimeout(async () => {
          // Sessiz Başarı (Silent Success) Mantığı (Kullanıcı talebi üzerine geri eklendi)
          console.warn("Sunucu 500 hatası verdi ancak işlem başarılı sayılıp tamamlanıyor (GMP Sessiz Başarı).");
          const payedPriceFloat = parseFloat(payedPrice);
            const totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
            let distributedAmount = 0;

            this.selectedPaymentGroup.forEach((group, index) => {
                const remaining = group.totalPrice - group.payedPrice;
                const pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
                const chunk = (index === this.selectedPaymentGroup.length - 1)
                    ? Math.round((payedPriceFloat - distributedAmount) * 100) / 100
                    : Math.round((payedPriceFloat * pRatio) * 100) / 100;

                group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
                distributedAmount += chunk;
                if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
                    group.status = "Ödendi";
                }
            });

            // Yerel değişiklikleri ana listeye geri yansıt (Merge back)
            this.selectedPaymentGroup.forEach((modifiedGroup) => {
               let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
               if (idx !== -1) {
                 this.$set(this.paymentGroups, idx, modifiedGroup);
               }
            });

            this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
            this.selectedPaymentGroup = [];
            this.reCalculatePaymentGroup();

            this.orderPayments.push({
                id: uuid.v1(),
                paymentMethod: this.selectedPaymentMethod,
                price: payedPrice
            });

            let clonedCart = Object.assign({}, this.$store.getters["selfservice/getCurrentCart"]);
            clonedCart.totalPayedPrice = Math.round((clonedCart.totalPayedPrice + payedPriceFloat) * 100) / 100;
            clonedCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
            
            this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
            const saveRes = await setBranchCart({ value: clonedCart, tableId: clonedCart.tableId, branchTableUId: clonedCart.branchTableUId });
            
            // CRITICAL [v25]: RowVersion sync after GMP silent success
            if (saveRes && saveRes.data && saveRes.data.rowVersion) {
                clonedCart.rowVersion = saveRes.data.rowVersion;
                if (this.currentCart) this.currentCart.rowVersion = saveRes.data.rowVersion;
                this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
                console.log("[RowVersion Sync] Updated after GMP silent success:", saveRes.data.rowVersion);
            }

            this.toggleCalc = false;
            
            this.paymentGroups = [...this.paymentGroups];
            this.$nextTick(() => {
              this.isTransaction = false;
              this.selectedCari = null;
              
              const remaining = this.calculateSelectedRemainingPrice(this.paymentGroups);
              const rounded = Math.round(remaining * 100) / 100;

              let checkRemainingAmount = rounded;
              if (this.currentCart) {
                checkRemainingAmount = this.currentCart.remainingAmount;
              }
              
              if ((rounded <= 0 || checkRemainingAmount <= 0) && this.isActive) {
                this.isCommitable = true;
                this.createCommitModel();
              }
            });
        }, 500);
      }
    },

    calculateTotalOriginPrice: function (selectedGroups) {
      var selectedPrice = 0;
      selectedGroups.forEach((item) => {
        item.entries.forEach((entry) => {
          let op = parseFloat(entry.originPrice || entry.OriginPrice || 0);
          let cp = parseFloat(entry.price || entry.Price || 0);
          
          // v153: Original price is at least as high as current price
          let price = Math.max(op, cp);
          
          // v138.5: Süresi devam eden ürünler için canlı fiyatı toplam orjinal fiyata ekle
          if (entry.isTime && entry.isRunning && entry.hourPrice) {
            const totalMs = this.getSafeTotalMs(entry);
            const totalMinutes = totalMs / (1000 * 60);
            const livePrice = Math.ceil(totalMinutes) * (entry.hourPrice / 60);
            if (livePrice > price) price = livePrice;
          }

          selectedPrice += price;
        });
      });
      return Math.round(selectedPrice * 100) / 100;
    },

    async commitPay(payedPrice, isDiscount) {

      if (this.selectedPaymentGroup.length == 0) {

        this.selectedPaymentGroup = this.paymentGroups;

      }

      var removeIndex = [];

      var tempGroup = {

        rowIndex: uuid.v1(),

        entries: [],

        totalPrice: 0,

        payedPrice: parseFloat(payedPrice),

        status: "Kalan",

      };

      // Oransal Dağıtım Mantığı (Merge yerini alıyor)
      var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
      var distributedAmount = 0;
      var payedPriceFloat = parseFloat(payedPrice);

      this.selectedPaymentGroup.forEach((group, index) => {
        var remaining = group.totalPrice - group.payedPrice;
        var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
        
        var chunk = 0;
        if (index === this.selectedPaymentGroup.length - 1) {
          // Son kalem kuruş farklarını alır
          chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
        } else {
          chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
        }
        
        group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
        if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
        
        distributedAmount += chunk;

        // Eğer tamamen ödendiyse durumunu güncelle
        if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
          group.status = "Ödendi";
        }
      });

      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
        this.selectedPaymentGroup
      );
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();

      var orderPayment = {

        id: uuid.v1(),

        paymentMethod: this.selectedPaymentMethod,

        price: payedPrice,

        value: isDiscount ? this.paymentDiscount.value : null,

        unit: isDiscount ? this.paymentDiscount.unit : null,

        description: isDiscount ? this.paymentDiscount.description : null,

      };

      this.orderPayments.push(orderPayment);

      this.toggleCalc = false;

      this.$vs.notify({
        color: "success",
        title: "Tebrikler",
        text: payedPrice + " TL Değerinde Ödeme Gerçekleşti.",
      });

      this.paymentGroups = [...this.paymentGroups];
      
      // Update global cart state
      var currCart = this.currentCart;
      currCart.paymentGroups = this.paymentGroups;
      currCart.totalPayedPrice = Math.round((currCart.totalPayedPrice + payedPriceFloat) * 100) / 100;
      currCart.remainingAmount = Math.round((currCart.totalPrice - currCart.totalPayedPrice) * 100) / 100;
      currCart.orderPayments = this.orderPayments;
      currCart.discounts = this.discounts;

      // Backend sync
      if (this.isTableMode && currCart.id) {
         try {
            let res = await getOrderEntries(currCart.id);
            if (res && res.data && res.data.rowVersion) {
               currCart.rowVersion = res.data.rowVersion;
            }
         } catch(e) { console.error("commitPay: Could not fetch rowVersion", e); }
      }
      await setBranchCart({ value: currCart, tableId: currCart.tableId, branchTableUId: currCart.branchTableUId });

      this.$nextTick(() => {
        this.isTransaction = false;
        
        const remaining = this.calculateSelectedRemainingPrice(this.paymentGroups);
        const rounded = Math.round(remaining * 100) / 100;
        
        if (rounded <= 0 && this.isActive) {
          console.log("commitPay: Auto-committing...");
          this.isCommitable = true;
          this.createCommitModel();
        }
      });
    },

    openQrReader(amount, isDiscount) {

      this.$refs.qrReader.isActive = true;

      this.$refs.qrReader.isWallet = true;

      this.$refs.qrReader.amount = amount.toFixed(2);

      this.$refs.qrReader.isDiscount = isDiscount;

    },

    calculateSelectedRemainingPrice: function (selectedGroups) {
      if (!selectedGroups) return 0;
      var selectedPrice = 0;
      selectedGroups.forEach((item) => {
        // v138.5: Süresi devam eden ürünler için canlı fiyatı hesapla
        let liveGroupTotal = 0;
        if (item.entries && item.entries.some(e => e.isTime && e.isRunning)) {
           liveGroupTotal = Math.max(0, this.calculateCurrentPrice(item) + (item.payedPrice || 0));
        } else {
           liveGroupTotal = (item.totalPrice || 0);
        }

        selectedPrice += (liveGroupTotal || 0) - (item.payedPrice || 0);
      });
      return Math.round(selectedPrice * 100) / 100;
    },

    closeCalculatorPage() {

      this.toggleCalc = false;

    },

    handleCariSelected(cari) {

      this.selectedCari = cari;

      // Cari seçildikten sonra ödeme işlemini başlat

      if (this.isPosEnabled) {

        this.doPay(

          this.selectedPaymentGroup.length > 0

            ? this.selectedGroupsPrice

            : this.totalPrice,

          false

        );

      } else {

        this.doPayWithoutPos(

          this.selectedPaymentGroup.length > 0

            ? this.selectedGroupsPrice

            : this.totalPrice,

          false

        );

      }

    },

    formatDateTimeLocal(date) {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const pad = (num) => String(num).padStart(2, '0');
      const year = d.getFullYear();
      const month = pad(d.getMonth() + 1);
      const day = pad(d.getDate());
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },

    getDisplayStartTime(paymentGroup) {
      if (!paymentGroup) return '';
      const entry = paymentGroup.entries.find(e => e.isTime);
      if (!entry) return '';
      const start = entry.lastStartTime || entry.createdDate;
      const startDate = this.parseSafeDate(start);
      return startDate.toLocaleString('tr-TR');
    },

    getMinStopTime(paymentGroup) {
      if (!paymentGroup) return '';
      const entry = paymentGroup.entries.find(e => e.isTime);
      if (!entry) return '';
      const start = entry.lastStartTime || entry.createdDate;
      const startDate = this.parseSafeDate(start);
      return this.formatDateTimeLocal(startDate);
    },

    openPicker(refName) {
      try {
        if (this.$refs[refName]) {
          this.$refs[refName].showPicker();
        }
      } catch (e) {
        console.error("showPicker not supported", e);
      }
    },

    openStopTimeEditPopup(paymentGroup) {
      if (!this.$isAdmin()) return;
      const entry = paymentGroup.entries.find(e => e.isTime && e.isRunning);
      if (!entry) return;

      this.selectedPaymentGroupForTimeEdit = paymentGroup;
      
      const now = new Date();
      this.customStopTime = this.formatDateTimeLocal(now);
      this.maxStopTime = this.formatDateTimeLocal(now);
      
      const start = entry.lastStartTime || entry.createdDate;
      const startDate = this.parseSafeDate(start);
      this.customStartTime = this.formatDateTimeLocal(startDate);
      this.minStopTime = this.formatDateTimeLocal(startDate);
      
      this.stopTimeEditPopupActive = true;
    },

    async saveAndStopTimer() {
      if (!this.selectedPaymentGroupForTimeEdit || !this.customStopTime || !this.customStartTime) return;

      const entry = this.selectedPaymentGroupForTimeEdit.entries.find(e => e.isTime && e.isRunning);
      if (!entry) return;

      const selectedStopDate = new Date(this.customStopTime);
      const selectedStartDate = new Date(this.customStartTime);
      const originalStart = entry.lastStartTime || entry.createdDate;
      const originalStartDate = this.parseSafeDate(originalStart);
      const now = new Date();

      // 1. Başlangıç zamanı limit kontrolü (max 10 saat geri çekme)
      const minAllowedStart = new Date(originalStartDate.getTime() - 10 * 60 * 60 * 1000);
      if (selectedStartDate < minAllowedStart) {
        this.$vs.notify({
          title: "Hata",
          text: "Başlangıç zamanı en fazla 10 saat geriye çekilebilir.",
          color: "danger"
        });
        return;
      }

      // 2. Gelecek zaman kontrolü
      if (selectedStartDate > now || selectedStopDate > now) {
        this.$vs.notify({
          title: "Hata",
          text: "Tarihler gelecek bir zaman olamaz.",
          color: "danger"
        });
        return;
      }

      // 3. Başlangıç ve bitiş zamanı aynı olamaz
      if (selectedStartDate.getTime() === selectedStopDate.getTime()) {
        this.$vs.notify({
          title: "Hata",
          text: "Başlangıç ve durdurma zamanı aynı olamaz.",
          color: "danger"
        });
        return;
      }

      // 4. Başlangıç zamanı durdurma zamanından sonra olamaz
      if (selectedStartDate > selectedStopDate) {
        this.$vs.notify({
          title: "Hata",
          text: "Başlangıç zamanı durdurma zamanından sonra olamaz.",
          color: "danger"
        });
        return;
      }

      this.stopTimeEditPopupActive = false;
      await this.stopTimeProduct(this.selectedPaymentGroupForTimeEdit, selectedStopDate, selectedStartDate);
    },

    openPriceEditDialog(paymentGroup) {

      // Only admin users can edit prices

      if (!this.$isAdmin() || (paymentGroup.totalPrice - paymentGroup.payedPrice === 0)) {

        return;

      }



      this.selectedPaymentGroupForEdit = paymentGroup;

      this.newPrice = (paymentGroup.totalPrice - paymentGroup.payedPrice).toFixed(2);

      this.priceEditPopupActive = true;

    },

    updatePrice() {

      if (!this.selectedPaymentGroupForEdit || !this.newPrice) return;



      const newPriceValue = parseFloat(this.newPrice);



      if (isNaN(newPriceValue) || newPriceValue < 0) {

        this.$vs.notify({

          title: "Hata",

          text: "Geçerli bir fiyat giriniz",

          color: "danger"

        });

        return;

      }



      // Calculate remaining price and the new total price

      const remainingPrice = this.selectedPaymentGroupForEdit.totalPrice - this.selectedPaymentGroupForEdit.payedPrice;

      const newTotalPrice = newPriceValue + this.selectedPaymentGroupForEdit.payedPrice;



      console.log("Fiyat Güncelleme:", {

        eski_kalan_fiyat: remainingPrice,

        yeni_kalan_fiyat: newPriceValue,

        eski_toplam_fiyat: this.selectedPaymentGroupForEdit.totalPrice,

        yeni_toplam_fiyat: newTotalPrice,

        odenen_miktar: this.selectedPaymentGroupForEdit.payedPrice

      });



      // Update price in cart entries and directly modify the cart

      const entries = this.selectedPaymentGroupForEdit.entries;

      const currentCart = this.$store.getters["selfservice/getCurrentCart"];



      if (entries.length === 1) {

        // If there's only one entry, update its price directly

        const entry = entries[0];



        // Find and update the corresponding entry in the current cart

        const cartEntry = currentCart.cartEntries.find(item =>

          item.id === entry.id ||

          (item.productId === entry.productId && item.variantId === entry.variantId)

        );



        if (cartEntry) {

          // Update price directly instead of adding a discount

          entry.originPrice += newTotalPrice - entry.price;

          cartEntry.price = newTotalPrice;

          entry.price = newTotalPrice;



          // If the entry has multiple quantity, adjust price per item

          if (entry.quantity > 1) {

            cartEntry.unitPrice = newTotalPrice / entry.quantity;

            entry.unitPrice = newTotalPrice / entry.quantity;

          }

        }

      } else {

        // If multiple entries, distribute price proportionally

        const totalOriginalPrice = entries.reduce((sum, entry) => sum + entry.price, 0);



        entries.forEach(entry => {

          const priceRatio = entry.price / totalOriginalPrice;

          const newEntryPrice = newTotalPrice * priceRatio;



          // Find and update the corresponding entry in the current cart

          const cartEntry = currentCart.cartEntries.find(item =>

            item.id === entry.id ||

            (item.productId === entry.productId && item.variantId === entry.variantId)

          );



          if (cartEntry) {

            // Update price directly

            entry.originPrice += newEntryPrice - entry.price;

            cartEntry.price = newEntryPrice;

            entry.price = newEntryPrice;

          }

        });

      }



      // Update payment group total price

      this.selectedPaymentGroupForEdit.totalPrice = newTotalPrice;



      // Recalculate cart's total price

      currentCart.totalPrice = currentCart.cartEntries.reduce((total, entry) => total + entry.price, 0);



      // Save changes to cart

      setBranchCart({ value: currentCart, tableId: currentCart.tableId, branchTableUId: currentCart.branchTableUId }).then(() => {

        this.$vs.notify({

          title: "Başarılı",

          text: "Fiyat başarıyla güncellendi",

          color: "success"

        });



        // Recalculate totals

        this.reCalculatePaymentGroup();



        // Close popup

        this.priceEditPopupActive = false;

      }).catch(error => {

        console.error("Fiyat güncellenirken hata oluştu:", error);

        this.$vs.notify({

          title: "Hata",

          text: "Fiyat güncellenirken bir hata oluştu",

          color: "danger"

        });

      });

    },

    // Telefon kilidi açıldığında sepetleri yeniden yükle

    handleVisibilityChange() {

      // Sayfa görünür hale geldiğinde ve component aktifse sepetleri yeniden yükle

      if (!document.hidden && this.isActive) {

        this.refreshCarts();

      }

    },

    async refreshCarts() {
      if (this.isTimerActionInProgress) {
        console.log("[TimerGuard] refreshCarts bypassed while timer action in progress.");
        return;
      }
      try {

        var carts = await getCarts();

        const parsedCarts = carts.data;

        if (parsedCarts.length > 0) {

          const currentCart = this.$store.getters["selfservice/getCurrentCart"];

          if (currentCart) {
            this.$store.dispatch(
              "selfservice/setToCart",
              parsedCarts.map((cart) => ({
                ...cart,
                active: cart.tableId === currentCart.tableId,
              }))
            );

            // Mevcut sepeti güncelle
            const updatedCurrentCart = parsedCarts.find(cart => cart.tableId === currentCart.tableId);
            if (updatedCurrentCart) {
              this.changeCart(updatedCurrentCart);
            }
          }

        }

      } catch (error) {

        console.error("Sepetler yenilenirken hata oluştu:", error);

      }

    },

  },

  created() {
    const savedCopyCount = localStorage.getItem("printCopyCount");
    if (savedCopyCount) {
      this.printCopyCount = parseInt(savedCopyCount);
    }

    const savedPrintPreference = localStorage.getItem("isPrintOrders");
    if (savedPrintPreference !== null) {
      this.isPrintOrders = savedPrintPreference === "true";
    }

    this.checkPosDevice();


    this.checkScreen();

    window.addEventListener("resize", this.checkScreen);

    window.addEventListener("visibilitychange", this.handleVisibilityChange);

  },

  beforeDestroy() {
    this.stopPosConnectionTimer();
    window.removeEventListener("resize", this.checkScreen);
    window.removeEventListener("visibilitychange", this.handleVisibilityChange);
    try {
      this.isActive = false;
      this.broadcastCartState();
    } catch (e) {
      console.error("Error clearing customer screen in beforeDestroy:", e);
    }
  },

};

</script>



<style>
@media (max-width: 767px) {

  #orderList {

    .vs-popup {

      height: auto;

      margin-top: auto;

      margin-left: 0;

      margin-right: 0;

      max-width: 100%;

      margin-bottom: 0;

      border-bottom-left-radius: 0 !important;

      border-bottom-right-radius: 0 !important;



      .vs-popup--close {

        transform: translate(0px, 0px);

      }

    }

    .vs-popup--content {

      padding-top: 0;

      padding-bottom: 0;

      height: auto;

    }

  }

}

.payment-log {

  border-bottom: 0.1rem solid black;

}



.payment-history::-webkit-scrollbar {

  height: 0;

  width: 0;

}



.payment-history {

  border: 0.1rem solid black;

  border-left: none;

  border-top: none;

  border-bottom: none;

  border-top-left-radius: 0 !important;

  border-top-right-radius: 0 !important;

  border-radius: 1rem;

  background: #ffd1d1;

  overflow: auto;

  max-height: 185px;

}



#orderListTable .vs-table--content {

  height: auto;

  margin-top: 0;

}



#orderListTable .vs-table {

  min-width: auto;

  width: 100%;

}

#orderListTable .vs-table--tbody {

  max-height: 55vh;

  overflow: auto;

  border-top: 0px solid;

}



#orderListTable .vs-table .td-check {

  min-width: 40px;

  width: 40px;

  max-width: 40px;

}



.calc-button .includeIconOnly {

  width: unset !important;

  height: unset !important;

}



.calc-button {

  padding: 1rem 0.5rem !important;

  width: fit-content;

  display: flex;

  margin-bottom: auto;

  margin-top: 3.75rem;

}



.calc-button .large-icon i {

  font-size: 1.5rem !important;

  color: var(--vs-primary);

}



.calc-button .small-icon i {

  font-size: 1rem !important;

  font-weight: bold;

}



.info-row {

  padding: 0.75rem 0.75rem !important;

  border-top: 1px solid;

  background: #f9f5f5 !important;

  font-size: 1.1rem !important;

  padding-bottom: 0 !important;

}



#orderList .vs-popup .vs-popup--content {

  height: auto !important;

  overflow: hidden;

  th {

    position: sticky;

    top: 0;

  }

}



#orderList .vs-popup .vs-popup--content {

  padding: 0 !important;

  margin: 0 !important;

  width: 100%;

}



@media (min-width: 768px) {

  #orderList .vs-popup {

    border-radius: 2rem !important;

  }

}



#orderList .vs-popup .vs-popup--header {

  display: none;

}



.payment-label {

  font-size: 1.25rem !important;

  padding-top: 0.5rem !important;

  padding-bottom: 0.5rem !important;

  border-bottom-left-radius: 0 !important;

  border-bottom-right-radius: 0 !important;

  border-top-left-radius: 2rem !important;

  border-top-right-radius: 2rem !important;

}



.payment-label i {

  font-size: 2rem !important;

  margin-right: 2rem !important;

}



#orderList .vs-table--tbody-table tr {

  background: none;

}



#orderList .giftsOpenerButton {

  z-index: 600;

}



#orderListTable .vs-table--content .vs-con-tbody .vs-table .vs-table--thead {

  background: #ffd1d1;

}



#orderListTable .con-tablex .vs-con-tbody .vs-table .vs-table--thead tr th .vs-table-text {

  border: none !important;

}



#orderListTable .con-tablex .vs-con-tbody .vs-table .vs-table--thead tr th {

  padding-bottom: 0 !important;

}



.column-head-text {

  font-size: 1.1rem !important;

  color: #543633 !important;

}



.tr-text {

  font-size: 1.1rem !important;

  font-weight: bold;

}



.tr-text-child {

  font-size: 1rem !important;

  font-weight: 600;

  font-style: italic;

}



.vs-table-primary .is-selected {

  background: #b8eeb8 !important;

}



.price-label {

  font-size: 1.1rem !important;

  color: #543633 !important;

  font-weight: 600 !important;

}



.price {

  font-size: 1.75rem !important;

  color: #543633 !important;

  line-height: 1.75rem !important;

}



.payed-row {

  color: rgb(130, 223, 130) !important;

  text-shadow: 0px 0px 3px rgb(226, 226, 226);

}

.swal2-container {
  z-index: 100001;
}

.line-through {
  text-decoration: line-through !important;
}
</style>

<style>
/* ... existing styles ... */



.vs-dialog-dark {

  z-index: 100001 !important;

}



.vs-dialog {

  z-index: 100001 !important;

}



.con-vs-dialog {

  z-index: 100001 !important;

}

@media screen and (max-width: 768px) {

  .vs-button.large {

    font-size: 0.8rem;

  }

}

@media screen and (max-width: 768px) {

  .vs-button.large:not(.includeIconOnly) {

    padding: 0.6rem 0.6rem !important;

  }

}



.close-btn {

  top: 50%;

  right: 0.5rem;

  transform: translateY(-50%);

}

.action-btns {

  width: calc(100% + 48px) !important;

  margin-left: -24px;

  margin-right: -24px;

  margin-bottom: 1rem;

}

.half-friendly-border {

  border-radius: 6px !important;

}



.clickable-price {

  cursor: pointer;

  transition: all 0.3s;

  position: relative;

}



.clickable-price:hover {

  color: #007bff !important;

  transform: scale(1.05);

}



.clickable-price:after {

  content: "✏️";

  font-size: 12px;

  position: absolute;

  top: -5px;

  right: -5px;

  opacity: 0;

  transition: opacity 0.3s;

}



.clickable-price:hover:after {

  opacity: 1;

}



/* Loading animation */

.rotating {

  animation: rotate 1s linear infinite;

}



@keyframes rotate {

  from {

    transform: rotate(0deg);

  }

  to {

    transform: rotate(360deg);

  }

}



.price-edit-popup {

  z-index: 100001 !important;

}



.price-edit-popup .vs-popup {

  width: 400px !important;

  max-width: 95vw !important;

}



@media screen and (max-width: 768px) {

  .price-edit-popup .vs-popup {

    width: 95vw !important;

  }

}



/* Merge Product Modal Styles */

#mergeProductModal .vs-popup .vs-popup--header {

  display: none !important;

}



#mergeProductModal .vs-popup .vs-popup--content {

  padding: 1.5rem !important;

  max-width: 550px !important;

  width: 90vw !important;

  max-height: 85vh !important;

}



#mergeProductModal .vs-popup {

  border-radius: 1rem !important;

}

/* Disabled payment button styles */
.vs-button:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background-color: #ccc !important;
}

/* Disabled time control button styles */
.time-control-buttons .vs-button:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background-color: #ccc !important;
  color: #666 !important;
}



.price-input {
  font-size: 2rem !important;
  background: #f2f2f2 0% 0% no-repeat padding-box !important;
  text-align: center !important;
  padding: 0.5rem !important;
  border: 1px solid #e1e1e1 !important;
  border-radius: 0.5rem !important;
}

.description-prompt-popup {
  z-index: 100001 !important;
}

.copy-count-wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  vertical-align: bottom;
}

.copy-count-label {
  font-size: 0.75rem;
  font-weight: bold;
  color: #6a1f13;
  margin-bottom: 2px;
}

.copy-count-input {
  width: 55px;
  height: 35px;
  text-align: center;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 900;
  color: #6a1f13;
  background: #fff;
  outline: none;
  transition: all 0.2s;
}

.copy-count-input:focus {
  border-color: #6a1f13;
  box-shadow: 0 0 4px rgba(106, 31, 19, 0.2);
}

.selected-row, .tr-values.selected-row {
  background-color: #c6efce !important;
  transition: background-color 0.2s;
}


.selected-row p, .selected-row span {
  color: #006100 !important;
}


</style>
